/**
 * SEO 配置 - text-to-video
 * 从 video-tools.ts 拆分，/text-to-video 页面独立 SEO 多语言文案
 */

export default {
    en: {
        textToVideo: {
            title: 'Free Text to Video AI: Prompts to Videos | WeryAI',
            description: 'Turn text prompts into cinematic AI videos for free. Powered by Veo 3.1, Sora 2, Kling & Seedance. Multiple ratios & durations supported. Try WeryAI now!',
            keywords: 'text to video AI, text to video generator free, AI text to video, prompt to video, txt2vid, AI video from text, text to video online, WeryAI',
            og_title: 'Free Text to Video AI: Prompts to Videos | WeryAI',
            og_description: 'Turn text prompts into cinematic AI videos for free. Powered by Veo 3.1, Sora 2, Kling & Seedance. Multiple ratios & durations supported. Try WeryAI now!',
            twitter_title: 'Free Text to Video AI: Prompts to Videos | WeryAI',
            twitter_description: 'Turn text prompts into cinematic AI videos for free. Powered by Veo 3.1, Sora 2, Kling & Seedance. Multiple ratios & durations supported. Try WeryAI now!',
            page: {
                title1: 'Free AI Text to Video Generator',
                title2: 'Simply type a prompt, and watch WeryAI bring your idea to life. Our Text to Video generator aggregates state-of-the-art models like Google Veo 3.1 and Kling AI, allowing you to create high-quality, physically accurate videos for social media (9:16) or cinematic projects (16:9) in seconds.',
                intro_title: 'Turn Imagination into Reality with Text to Video AI',
                feature_title: 'Features of WeryAI Text to Video',
                faq_title: 'Frequently Asked Questions about Text to Video',
                feature_title1: 'Multi-Model Powerhouse',
                feature_desc1: 'Switch between Veo 3.1 for realism and Kling for motion consistency. No need for multiple subscriptions.',
                feature_title2: 'Custom Aspect Ratios',
                feature_desc2: 'Generate vertical videos (9:16) for TikTok/Reels or widescreen (16:9) for YouTube directly.',
                feature_title3: 'Extended Duration',
                feature_desc3: 'Create videos up to 8 seconds (or longer with extensions) in a single generation, perfect for storytelling.',
                faq: [
                    {
                        question: 'How do I write a good prompt for AI text to video?',
                        answer: `Be specific. Describe the subject, action, lighting, and camera angle. For example: "A cinematic drone shot of a futuristic cyberpunk city at night, neon lights, 4k resolution." WeryAI's integrated models understand complex descriptions well.`,
                    },
                    {
                        question: 'Which model should I use: Google Veo 3.1 or Kling?',
                        answer: 'Google Veo 3.1 offers exceptional visual fidelity and prompt adherence, ideal for realistic scenes. Kling AI often performs better for complex character movements. We recommend trying both to see which fits your specific scene.',
                    },
                    {
                        question: 'Can I use WeryAI Text to Video for free?',
                        answer: 'Yes! New users get free credits on signup -- no credit card required. You can also earn more free credits every day through daily check-in, completing tasks, and inviting friends. Free credits let you create multiple clips to test different prompts and models.',
                    },
                    {
                        question: 'Can I generate videos longer than 8 seconds?',
                        answer: 'The base generation creates clips up to 8s (depending on the model). To make longer videos, you can use our AI Video Extender tool to seamlessly continue the footage.',
                    },
                    {
                        question: 'Do the generated videos have sound?',
                        answer: 'Yes, you can enable the "Generate Audio" toggle (as seen in the tool) to create matching sound effects and background ambience automatically.',
                    },
                    {
                        question: 'What other AI video creation methods does WeryAI offer?',
                        answer: 'Besides Text to Video, WeryAI offers <a href="/image-to-video">Image to Video</a> to animate your photos into motion, and <a href="/video-to-video">Video to Video</a> to restyle existing footage into anime, 3D art, or cyberpunk. All tools share the same free daily credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'How do I write a good prompt for AI text to video?',
                    answer: `Be specific. Describe the subject, action, lighting, and camera angle. For example: "A cinematic drone shot of a futuristic cyberpunk city at night, neon lights, 4k resolution." WeryAI's integrated models understand complex descriptions well.`,
                },
                {
                    question: 'Which model should I use: Google Veo 3.1 or Kling?',
                    answer: 'Google Veo 3.1 offers exceptional visual fidelity and prompt adherence, ideal for realistic scenes. Kling AI often performs better for complex character movements. We recommend trying both to see which fits your specific scene.',
                },
                {
                    question: 'Can I use WeryAI Text to Video for free?',
                    answer: 'Yes! New users get free credits on signup -- no credit card required. You can also earn more free credits every day through daily check-in, completing tasks, and inviting friends. Free credits let you create multiple clips to test different prompts and models.',
                },
                {
                    question: 'Can I generate videos longer than 8 seconds?',
                    answer: 'The base generation creates clips up to 8s (depending on the model). To make longer videos, you can use our AI Video Extender tool to seamlessly continue the footage.',
                },
                {
                    question: 'Do the generated videos have sound?',
                    answer: 'Yes, you can enable the "Generate Audio" toggle (as seen in the tool) to create matching sound effects and background ambience automatically.',
                },
                {
                    question: 'What other AI video creation methods does WeryAI offer?',
                    answer: 'Besides Text to Video, WeryAI offers Image to Video to animate your photos into motion, and Video to Video to restyle existing footage into anime, 3D art, or cyberpunk. All tools share the same free daily credits.',
                },
            ],
        },
    },
    zh: {
        textToVideo: {
            title: '免费 AI 文生视频：提示词一键生成视频 | WeryAI',
            description: '免费将文字提示词转化为电影感 AI 视频。由 Veo 3.1、Sora 2、Kling 和 Seedance 驱动，支持多种比例与时长。立即体验 WeryAI！',
            keywords: '文生视频, AI 文本转视频, 免费文生视频, 提示词生成视频, txt2vid, AI 视频生成器, 在线文生视频, WeryAI',
            og_title: '免费 AI 文生视频：提示词一键生成视频 | WeryAI',
            og_description: '免费将文字提示词转化为电影感 AI 视频。由 Veo 3.1、Sora 2、Kling 和 Seedance 驱动，支持多种比例与时长。立即体验 WeryAI！',
            twitter_title: '免费 AI 文生视频：提示词一键生成视频 | WeryAI',
            twitter_description: '免费将文字提示词转化为电影感 AI 视频。由 Veo 3.1、Sora 2、Kling 和 Seedance 驱动，支持多种比例与时长。立即体验 WeryAI！',
            page: {
                title1: '免费 AI 文生视频生成器',
                title2: '只需输入一段提示词，就能看到 WeryAI 把你的想法变成视频。我们的文生视频工具聚合了 Google Veo 3.1、Kling 等顶尖模型，让你在几秒内生成高质量、物理一致的短视频：既适合社媒竖屏（9:16），也适合电影横屏（16:9）。',
                intro_title: '用文生视频 AI 将想象变为现实',
                feature_title: 'WeryAI 文生视频的核心功能',
                faq_title: '文生视频常见问题',
                feature_title1: '多模型强力聚合',
                feature_desc1: '需要写实效果就选 Veo 3.1，需要动作一致性就选 Kling。无需分别订阅多个平台。',
                feature_title2: '自定义画面比例',
                feature_desc2: '直接生成 9:16 竖屏视频（TikTok/Reels）或 16:9 横屏视频（YouTube/电影项目）。',
                feature_title3: '更长时长',
                feature_desc3: '单次生成最长 8 秒（不同模型略有差异），也可用 AI 视频延长工具无缝续写，适合叙事内容。',
                faq: [
                    {
                        question: '如何写出好的文生视频提示词？',
                        answer: '尽量具体：描述主体、动作、光线与镜头语言。例如："夜晚的未来赛博朋克城市航拍镜头，霓虹灯，4K 质感"。WeryAI 集成的模型对复杂描述理解更好。',
                    },
                    {
                        question: '我该选 Google Veo 3.1 还是 Kling？',
                        answer: 'Google Veo 3.1 在画面质感与提示词贴合度上非常出色，适合写实场景；Kling AI 往往更擅长复杂人物动作与运动一致性。建议都试一下，看哪个更贴合你的素材。',
                    },
                    {
                        question: 'WeryAI 的文生视频可以免费使用吗？',
                        answer: '是的！新用户注册即送免费积分，无需绑定信用卡。你还可以通过每日签到、完成任务和邀请好友获得更多免费积分。免费积分可用于生成多个片段，测试不同的提示词与模型。',
                    },
                    {
                        question: '我可以生成超过 8 秒的视频吗？',
                        answer: '基础生成通常最长可到 8 秒（取决于模型）。想要更长视频，可使用我们的 AI 视频延长工具，在保持风格与内容连贯的前提下继续生成。',
                    },
                    {
                        question: '生成的视频会带声音吗？',
                        answer: '会的。你可以开启"生成音频（Generate Audio）"开关，自动生成匹配的音效与环境氛围声。',
                    },
                    {
                        question: 'WeryAI 还提供哪些 AI 视频创作方式？',
                        answer: '除了文生视频，WeryAI 还提供 <a href="/image-to-video">Image to Video</a>（将照片动画化）和 <a href="/video-to-video">Video to Video</a>（将现有视频转换为动漫、3D 或赛博朋克风格）。所有工具共享每日免费积分。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何写出好的文生视频提示词？',
                    answer: '尽量具体：描述主体、动作、光线与镜头语言。例如："夜晚的未来赛博朋克城市航拍镜头，霓虹灯，4K 质感"。',
                },
                {
                    question: '我该选 Google Veo 3.1 还是 Kling？',
                    answer: 'Veo 3.1 更擅长写实与提示词贴合，Kling 更擅长动作一致性。建议都试试再决定。',
                },
                {
                    question: 'WeryAI 的文生视频可以免费使用吗？',
                    answer: '是的！新用户注册即送免费积分，无需绑定信用卡。还可通过每日签到、完成任务和邀请好友持续获得免费积分，畅享文生视频创作。',
                },
                {
                    question: '我可以生成超过 8 秒的视频吗？',
                    answer: '基础生成通常最长到 8 秒；更长时长可使用 AI 视频延长工具无缝续写。',
                },
                {
                    question: '生成的视频会带声音吗？',
                    answer: '可以。开启"生成音频"开关即可自动生成匹配的音效与氛围声。',
                },
                {
                    question: 'WeryAI 还提供哪些 AI 视频创作方式？',
                    answer: '除了文生视频，WeryAI 还提供 Image to Video（将照片动画化）和 Video to Video（将现有视频转换为动漫、3D 或赛博朋克风格）。所有工具共享每日免费积分。',
                },
            ],
        },
    },
    ja: {
        textToVideo: {
            title: '無料 AI テキスト→動画：プロンプトで動画生成 | WeryAI',
            description: 'テキストプロンプトを映画品質のAI動画に無料変換。Veo 3.1、Sora 2、Kling、Seedance搭載。複数アスペクト比・長さ対応。WeryAIを今すぐ体験！',
            keywords: 'テキストから動画, text to video AI, AI動画生成 無料, プロンプトで動画, txt2vid, テキスト動画変換, AI動画メーカー, WeryAI',
            og_title: '無料 AI テキスト→動画：プロンプトで動画生成 | WeryAI',
            og_description: 'テキストプロンプトを映画品質のAI動画に無料変換。Veo 3.1、Sora 2、Kling、Seedance搭載。複数アスペクト比・長さ対応。WeryAIを今すぐ体験！',
            twitter_title: '無料 AI テキスト→動画：プロンプトで動画生成 | WeryAI',
            twitter_description: 'テキストプロンプトを映画品質のAI動画に無料変換。Veo 3.1、Sora 2、Kling、Seedance搭載。複数アスペクト比・長さ対応。WeryAIを今すぐ体験！',
            page: {
                title1: '無料 AI テキスト→動画ジェネレーター',
                title2: 'プロンプトを入力するだけで、WeryAI があなたのアイデアを動画にします。Google Veo 3.1 や Kling などの最先端モデルを統合しており、SNS向けの縦動画（9:16）からシネマ向け横動画（16:9）まで、高品質で物理的に自然な映像を数秒で生成できます。',
                intro_title: 'テキスト→動画AIで想像を現実に',
                feature_title: 'WeryAI テキスト→動画の特徴',
                faq_title: 'テキスト→動画のよくある質問',
                feature_title1: 'マルチモデル対応',
                feature_desc1: 'リアルさは Veo 3.1、動きの一貫性は Kling。複数サブスクは不要です。',
                feature_title2: 'アスペクト比を自由に',
                feature_desc2: 'TikTok/Reels 向け 9:16、YouTube 向け 16:9 をそのまま生成できます。',
                feature_title3: '最長 8 秒（延長も可）',
                feature_desc3: '一度の生成で最大 8 秒（モデルにより異なる）。さらに延長ツールでシームレスに続編を作れます。',
                faq: [
                    {
                        question: '良いテキスト→動画プロンプトの書き方は？',
                        answer: '被写体、動き、光、カメラ角度を具体的に書きましょう。例：「夜の未来的なサイバーパンク都市をドローンで撮影、ネオン、4K」。統合モデルは複雑な説明も理解できます。',
                    },
                    {
                        question: 'Google Veo 3.1 と Kling、どちらを使うべき？',
                        answer: 'Veo 3.1 は画質とプロンプト追従に優れ、写実的なシーンに最適です。Kling は複雑な人物動作で強みを発揮することが多いです。両方試して最適な方を選ぶのがおすすめです。',
                    },
                    {
                        question: 'WeryAI のテキスト→動画は無料で使えますか？',
                        answer: 'はい！新規登録で無料クレジットがもらえます。クレジットカード不要です。さらに毎日のチェックイン、タスク達成、友人招待で追加の無料クレジットを獲得できます。無料クレジットで複数クリップを生成して比較できます。',
                    },
                    {
                        question: '8 秒より長い動画は作れますか？',
                        answer: '基本生成は最大 8 秒（モデルにより異なります）。より長い動画は AI Video Extender で自然に延長できます。',
                    },
                    {
                        question: '生成動画に音は付きますか？',
                        answer: 'はい。ツール内の「Generate Audio」トグルをオンにすると、効果音や環境音を自動生成できます。',
                    },
                    {
                        question: 'WeryAI には他にどんな AI 動画作成方法がありますか？',
                        answer: 'テキスト→動画のほかに、<a href="/image-to-video">Image to Video</a>（写真をアニメーション化）や <a href="/video-to-video">Video to Video</a>（既存映像をアニメ・3D・サイバーパンク風にリスタイル）も提供しています。すべてのツールで毎日の無料クレジットを共有できます。',
                    },
                ],
            },
            faq: [
                {
                    question: '良いテキスト→動画プロンプトの書き方は？',
                    answer: '被写体、動き、光、カメラ角度を具体的に。例：「夜のサイバーパンク都市をドローン撮影、ネオン、4K」。',
                },
                {
                    question: 'Google Veo 3.1 と Kling、どちらを使うべき？',
                    answer: '写実と追従性なら Veo 3.1、動きの一貫性なら Kling。両方試すのがおすすめです。',
                },
                {
                    question: 'WeryAI のテキスト→動画は無料で使えますか？',
                    answer: 'はい！新規登録で無料クレジットを獲得でき、クレジットカードは不要です。毎日のチェックイン・タスク・友人招待でさらに無料クレジットが貯まり、テキストから動画を継続的にお試しいただけます。',
                },
                {
                    question: '8 秒より長い動画は作れますか？',
                    answer: '基本は最大 8 秒。AI Video Extender を使えばシームレスに延長できます。',
                },
                {
                    question: '生成動画に音は付きますか？',
                    answer: 'はい。「Generate Audio」を有効にすると、音を自動生成できます。',
                },
                {
                    question: 'WeryAI には他にどんな AI 動画作成方法がありますか？',
                    answer: 'テキスト→動画のほかに、Image to Video（写真をアニメーション化）や Video to Video（既存映像をアニメ・3D・サイバーパンク風にリスタイル）も提供。すべてのツールで毎日の無料クレジットを共有できます。',
                },
            ],
        },
    },
    ko: {
        textToVideo: {
            title: '무료 AI 텍스트→비디오: 프롬프트로 영상 생성 | WeryAI',
            description: '텍스트 프롬프트를 시네마틱 AI 영상으로 무료 변환. Veo 3.1, Sora 2, Kling & Seedance 지원. 다양한 비율과 길이. 지금 WeryAI를 체험하세요!',
            keywords: '텍스트 비디오 변환 AI, 무료 텍스트 비디오 생성기, AI 텍스트 비디오, 프롬프트 영상 생성, txt2vid, 텍스트로 영상 만들기, WeryAI',
            og_title: '무료 AI 텍스트→비디오: 프롬프트로 영상 생성 | WeryAI',
            og_description: '텍스트 프롬프트를 시네마틱 AI 영상으로 무료 변환. Veo 3.1, Sora 2, Kling & Seedance 지원. 다양한 비율과 길이. 지금 WeryAI를 체험하세요!',
            twitter_title: '무료 AI 텍스트→비디오: 프롬프트로 영상 생성 | WeryAI',
            twitter_description: '텍스트 프롬프트를 시네마틱 AI 영상으로 무료 변환. Veo 3.1, Sora 2, Kling & Seedance 지원. 다양한 비율과 길이. 지금 WeryAI를 체험하세요!',
            page: {
                title1: '무료 AI 텍스트→비디오 생성기',
                title2: '프롬프트만 입력하면 WeryAI가 아이디어를 영상으로 만들어줍니다. Google Veo 3.1, Kling 등 최신 모델을 한곳에 모아, 소셜용 세로 영상(9:16)부터 시네마용 가로 영상(16:9)까지 고품질·물리적으로 자연스러운 영상을 몇 초 만에 생성할 수 있습니다.',
                intro_title: '텍스트→비디오 AI로 상상을 현실로',
                feature_title: 'WeryAI 텍스트→비디오 기능',
                faq_title: '텍스트→비디오 FAQ',
                feature_title1: '멀티 모델 파워',
                feature_desc1: '현실감은 Veo 3.1, 모션 일관성은 Kling. 여러 구독이 필요 없습니다.',
                feature_title2: '맞춤 화면 비율',
                feature_desc2: 'TikTok/Reels용 9:16 세로, YouTube용 16:9 가로를 바로 생성하세요.',
                feature_title3: '최대 8초(연장 가능)',
                feature_desc3: '한 번의 생성으로 최대 8초(모델별 상이). 연장 도구로 자연스럽게 이어서 만들 수 있습니다.',
                faq: [
                    {
                        question: '좋은 텍스트→비디오 프롬프트는 어떻게 쓰나요?',
                        answer: '구체적으로 작성하세요. 주제, 동작, 조명, 카메라 앵글을 포함하면 좋습니다. 예: "밤의 미래 사이버펑크 도시 드론 샷, 네온, 4K".',
                    },
                    {
                        question: 'Google Veo 3.1과 Kling 중 무엇을 써야 하나요?',
                        answer: 'Veo 3.1은 시각적 디테일과 프롬프트 준수에 강해 현실적인 장면에 적합합니다. Kling은 복잡한 캐릭터 움직임에서 더 좋은 경우가 많습니다. 둘 다 테스트해보길 권장합니다.',
                    },
                    {
                        question: 'WeryAI 텍스트→비디오를 무료로 사용할 수 있나요?',
                        answer: '네! 신규 가입 시 무료 크레딧이 제공되며, 신용카드가 필요 없습니다. 매일 출석 체크, 미션 완료, 친구 초대를 통해 추가 무료 크레딧을 받을 수 있습니다. 무료 크레딧으로 다양한 프롬프트와 모델을 테스트해 보세요.',
                    },
                    {
                        question: '8초보다 긴 영상을 만들 수 있나요?',
                        answer: '기본 생성은 최대 8초(모델별 상이)입니다. 더 길게 만들려면 AI Video Extender 도구로 자연스럽게 이어서 생성하세요.',
                    },
                    {
                        question: '생성된 영상에 소리가 있나요?',
                        answer: '네. 도구에서 "Generate Audio" 토글을 켜면 효과음과 배경 앰비언스를 자동으로 생성할 수 있습니다.',
                    },
                    {
                        question: 'WeryAI는 다른 AI 영상 제작 방법도 제공하나요?',
                        answer: '텍스트→비디오 외에도 <a href="/image-to-video">Image to Video</a>(사진을 모션 영상으로 변환)와 <a href="/video-to-video">Video to Video</a>(기존 영상을 애니메이션·3D·사이버펑크 스타일로 변환)를 제공합니다. 모든 도구는 동일한 무료 일일 크레딧을 공유합니다.',
                    },
                ],
            },
            faq: [
                {
                    question: '좋은 텍스트→비디오 프롬프트는 어떻게 쓰나요?',
                    answer: '주제·동작·조명·카메라 앵글을 구체적으로 쓰세요. 예: "사이버펑크 도시 드론 샷, 네온, 4K".',
                },
                {
                    question: 'Google Veo 3.1과 Kling 중 무엇을 써야 하나요?',
                    answer: '현실감/준수는 Veo 3.1, 모션 일관성은 Kling이 강점입니다. 둘 다 시도해보세요.',
                },
                {
                    question: 'WeryAI 텍스트→비디오를 무료로 사용할 수 있나요?',
                    answer: '네! 가입 즉시 무료 크레딧 제공, 신용카드 불필요. 매일 출석 체크·미션 완료·친구 초대로 계속 무료 크레딧을 받아 텍스트→비디오를 체험할 수 있습니다.',
                },
                {
                    question: '8초보다 긴 영상을 만들 수 있나요?',
                    answer: '기본은 최대 8초이며, 연장 도구로 더 길게 이어서 만들 수 있습니다.',
                },
                {
                    question: '생성된 영상에 소리가 있나요?',
                    answer: '네. "Generate Audio"를 켜면 자동 생성됩니다.',
                },
                {
                    question: 'WeryAI는 다른 AI 영상 제작 방법도 제공하나요?',
                    answer: '텍스트→비디오 외에도 Image to Video(사진을 모션 영상으로 변환)와 Video to Video(기존 영상을 애니메이션·3D·사이버펑크 스타일로 변환)를 제공합니다. 모든 도구는 동일한 무료 일일 크레딧을 공유합니다.',
                },
            ],
        },
    },
    es: {
        textToVideo: {
            title: 'IA Texto a Video Gratis: Prompts a Videos | WeryAI',
            description: 'Convierte prompts de texto en videos cinematográficos con IA gratis. Con Veo 3.1, Sora 2, Kling y Seedance. Múltiples proporciones y duraciones. ¡Prueba WeryAI!',
            keywords: 'texto a video IA, generador texto a video gratis, IA texto a video, prompt a video, txt2vid, video IA desde texto, texto a video online, WeryAI',
            og_title: 'IA Texto a Video Gratis: Prompts a Videos | WeryAI',
            og_description: 'Convierte prompts de texto en videos cinematográficos con IA gratis. Con Veo 3.1, Sora 2, Kling y Seedance. Múltiples proporciones y duraciones. ¡Prueba WeryAI!',
            twitter_title: 'IA Texto a Video Gratis: Prompts a Videos | WeryAI',
            twitter_description: 'Convierte prompts de texto en videos cinematográficos con IA gratis. Con Veo 3.1, Sora 2, Kling y Seedance. Múltiples proporciones y duraciones. ¡Prueba WeryAI!',
            page: {
                title1: 'Generador IA de Texto a Video Gratis',
                title2: 'Escribe un prompt y mira cómo WeryAI convierte tu idea en video. Nuestro generador de Texto a Video integra modelos de última generación como Google Veo 3.1 y Kling, para crear videos de alta calidad y movimiento natural para redes (9:16) o proyectos cinemáticos (16:9) en segundos.',
                intro_title: 'Convierte la imaginación en realidad con Texto a Video',
                feature_title: 'Funciones del Texto a Video de WeryAI',
                faq_title: 'Preguntas frecuentes sobre Texto a Video',
                feature_title1: 'Potencia multi‑modelo',
                feature_desc1: 'Alterna entre Veo 3.1 para realismo y Kling para consistencia de movimiento. Sin múltiples suscripciones.',
                feature_title2: 'Relaciones de aspecto personalizadas',
                feature_desc2: 'Genera videos verticales (9:16) para TikTok/Reels o widescreen (16:9) para YouTube.',
                feature_title3: 'Duración extendida',
                feature_desc3: 'Crea videos de hasta 8 s (o más con extensiones) en una sola generación, ideal para storytelling.',
                faq: [
                    {
                        question: '¿Cómo escribo un buen prompt para texto a video?',
                        answer: 'Sé específico: sujeto, acción, iluminación y ángulo de cámara. Ejemplo: "Toma de dron cinematográfica de una ciudad cyberpunk futurista de noche, luces neón, resolución 4K".',
                    },
                    {
                        question: '¿Qué modelo uso: Google Veo 3.1 o Kling?',
                        answer: 'Google Veo 3.1 ofrece gran fidelidad visual y adherencia al prompt, ideal para escenas realistas. Kling suele rendir mejor en movimientos complejos de personajes. Recomendamos probar ambos.',
                    },
                    {
                        question: '¿Puedo usar WeryAI Texto a Video gratis?',
                        answer: '¡Sí! Los nuevos usuarios obtienen créditos gratis al registrarse, sin necesidad de tarjeta de crédito. También puedes ganar más créditos gratis cada día con el check-in diario, completando tareas e invitando amigos. Los créditos gratis te permiten crear varios clips para comparar prompts y modelos.',
                    },
                    {
                        question: '¿Puedo generar videos de más de 8 segundos?',
                        answer: 'La generación base llega hasta 8 s (según el modelo). Para videos más largos, usa nuestra herramienta AI Video Extender para continuar el metraje sin cortes.',
                    },
                    {
                        question: '¿Los videos generados tienen sonido?',
                        answer: 'Sí. Puedes activar el interruptor "Generate Audio" para crear automáticamente efectos de sonido y ambiente.',
                    },
                    {
                        question: '¿Qué otros métodos de creación de video IA ofrece WeryAI?',
                        answer: 'Además de Texto a Video, WeryAI ofrece <a href="/image-to-video">Image to Video</a> para animar tus fotos y <a href="/video-to-video">Video to Video</a> para transformar metraje existente en anime, arte 3D o cyberpunk. Todas las herramientas comparten los mismos créditos diarios gratuitos.',
                    },
                ],
            },
            faq: [
                {
                    question: '¿Cómo escribo un buen prompt para texto a video?',
                    answer: 'Sé específico: sujeto, acción, iluminación y cámara. Ejemplo: "Ciudad cyberpunk de noche, neón, dron, 4K".',
                },
                {
                    question: '¿Qué modelo uso: Google Veo 3.1 o Kling?',
                    answer: 'Veo 3.1 destaca en realismo y adherencia al prompt; Kling suele ser mejor en movimientos complejos. Prueba ambos.',
                },
                {
                    question: '¿Puedo usar WeryAI Texto a Video gratis?',
                    answer: '¡Sí! Al registrarte recibes créditos gratis sin tarjeta de crédito. Gana más créditos diariamente con check-in, tareas e invitaciones a amigos para seguir creando videos desde texto.',
                },
                {
                    question: '¿Puedo generar videos de más de 8 segundos?',
                    answer: 'La base llega hasta 8 s; para más duración, usa AI Video Extender.',
                },
                {
                    question: '¿Los videos generados tienen sonido?',
                    answer: 'Sí. Activa "Generate Audio" para generar audio automáticamente.',
                },
                {
                    question: '¿Qué otros métodos de creación de video IA ofrece WeryAI?',
                    answer: 'Además de Texto a Video, WeryAI ofrece Image to Video para animar tus fotos y Video to Video para transformar metraje existente en anime, arte 3D o cyberpunk. Todas las herramientas comparten los mismos créditos diarios gratuitos.',
                },
            ],
        },
    },
    fr: {
        textToVideo: {
            title: 'IA Texte vers Vidéo Gratuit : Prompts en Vidéos | WeryAI',
            description: 'Transformez vos prompts en vidéos IA cinématographiques gratuitement. Veo 3.1, Sora 2, Kling & Seedance réunis. Multiples formats et durées. Essayez WeryAI !',
            keywords: 'texte vers vidéo IA, générateur texte vidéo gratuit, IA texte en vidéo, prompt vers vidéo, txt2vid, vidéo IA depuis texte, texte en vidéo en ligne, WeryAI',
            og_title: 'IA Texte vers Vidéo Gratuit : Prompts en Vidéos | WeryAI',
            og_description: 'Transformez vos prompts en vidéos IA cinématographiques gratuitement. Veo 3.1, Sora 2, Kling & Seedance réunis. Multiples formats et durées. Essayez WeryAI !',
            twitter_title: 'IA Texte vers Vidéo Gratuit : Prompts en Vidéos | WeryAI',
            twitter_description: 'Transformez vos prompts en vidéos IA cinématographiques gratuitement. Veo 3.1, Sora 2, Kling & Seedance réunis. Multiples formats et durées. Essayez WeryAI !',
            page: {
                title1: 'Générateur IA Texte→Vidéo gratuit',
                title2: 'Écrivez un prompt et regardez WeryAI donner vie à votre idée. Notre outil Texte→Vidéo agrège des modèles de pointe comme Google Veo 3.1 et Kling AI, afin de créer en quelques secondes des vidéos de haute qualité et physiquement cohérentes pour les réseaux (9:16) ou des projets cinématiques (16:9).',
                intro_title: 'Transformez l\'imagination en réalité avec l\'IA Texte→Vidéo',
                feature_title: 'Fonctionnalités de WeryAI Texte→Vidéo',
                faq_title: 'Questions fréquentes sur Texte→Vidéo',
                feature_title1: 'Puissance multi‑modèles',
                feature_desc1: 'Passez de Veo 3.1 pour le réalisme à Kling pour la cohérence du mouvement. Plus besoin de plusieurs abonnements.',
                feature_title2: 'Formats personnalisés',
                feature_desc2: 'Générez des vidéos verticales (9:16) pour TikTok/Reels ou 16:9 pour YouTube directement.',
                feature_title3: 'Durée étendue',
                feature_desc3: 'Créez des vidéos jusqu\'à 8 s (ou plus avec extensions) en une seule génération, idéal pour le storytelling.',
                faq: [
                    {
                        question: 'Comment écrire un bon prompt pour texte→vidéo ?',
                        answer: 'Soyez précis : sujet, action, éclairage et angle de caméra. Exemple : « prise de drone cinématographique d\'une ville cyberpunk futuriste la nuit, néons, 4K ».',
                    },
                    {
                        question: 'Quel modèle choisir : Google Veo 3.1 ou Kling ?',
                        answer: 'Google Veo 3.1 offre une excellente fidélité visuelle et une bonne adhérence au prompt, idéal pour des scènes réalistes. Kling est souvent meilleur pour des mouvements de personnages complexes. Testez les deux pour trouver le meilleur rendu.',
                    },
                    {
                        question: 'Puis-je utiliser WeryAI Texte→Vidéo gratuitement ?',
                        answer: 'Oui ! Les nouveaux utilisateurs reçoivent des crédits gratuits à l\'inscription, sans carte bancaire. Vous pouvez aussi gagner plus de crédits gratuits chaque jour grâce au check-in quotidien, aux tâches et aux invitations d\'amis. Les crédits gratuits vous permettent de créer plusieurs clips pour tester différents prompts et modèles.',
                    },
                    {
                        question: 'Puis-je générer des vidéos de plus de 8 secondes ?',
                        answer: 'La génération de base va jusqu\'à 8 s (selon le modèle). Pour des vidéos plus longues, utilisez notre outil AI Video Extender pour continuer la séquence de manière fluide.',
                    },
                    {
                        question: 'Les vidéos générées ont-elles du son ?',
                        answer: 'Oui. Activez l\'option « Generate Audio » pour générer automatiquement des effets sonores et une ambiance.',
                    },
                    {
                        question: 'Quelles autres méthodes de création vidéo IA propose WeryAI ?',
                        answer: 'En plus du Texte→Vidéo, WeryAI propose <a href="/image-to-video">Image to Video</a> pour animer vos photos et <a href="/video-to-video">Video to Video</a> pour transformer des séquences existantes en anime, art 3D ou cyberpunk. Tous les outils partagent les mêmes crédits gratuits quotidiens.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Comment écrire un bon prompt pour texte→vidéo ?',
                    answer: 'Décrivez le sujet, l\'action, la lumière et la caméra. Exemple : « ville cyberpunk la nuit, néons, drone, 4K ».',
                },
                {
                    question: 'Quel modèle choisir : Google Veo 3.1 ou Kling ?',
                    answer: 'Veo 3.1 est fort en réalisme et adhérence, Kling en mouvement. Essayez les deux.',
                },
                {
                    question: 'Puis-je utiliser WeryAI Texte→Vidéo gratuitement ?',
                    answer: 'Oui ! Crédits gratuits offerts à l\'inscription, sans carte bancaire. Gagnez-en davantage chaque jour via le check-in, les tâches et les invitations d\'amis pour continuer à créer des vidéos à partir de texte.',
                },
                {
                    question: 'Puis-je générer des vidéos de plus de 8 secondes ?',
                    answer: 'Base jusqu\'à 8 s ; pour plus long, utilisez AI Video Extender.',
                },
                {
                    question: 'Les vidéos générées ont-elles du son ?',
                    answer: 'Oui. Activez « Generate Audio » pour générer l\'audio automatiquement.',
                },
                {
                    question: 'Quelles autres méthodes de création vidéo IA propose WeryAI ?',
                    answer: 'En plus du Texte→Vidéo, WeryAI propose Image to Video pour animer vos photos et Video to Video pour transformer des séquences existantes en anime, art 3D ou cyberpunk. Tous les outils partagent les mêmes crédits gratuits quotidiens.',
                },
            ],
        },
    },
    de: {
        textToVideo: {
            title: 'Kostenlose KI Text-zu-Video: Prompts zu Videos | WeryAI',
            description: 'Verwandeln Sie Text-Prompts kostenlos in filmische KI-Videos. Mit Veo 3.1, Sora 2, Kling & Seedance. Mehrere Seitenverhältnisse & Dauern. Jetzt WeryAI testen!',
            keywords: 'Text zu Video KI, Text zu Video Generator kostenlos, KI Text zu Video, Prompt zu Video, txt2vid, KI-Video aus Text, Text zu Video online, WeryAI',
            og_title: 'Kostenlose KI Text-zu-Video: Prompts zu Videos | WeryAI',
            og_description: 'Verwandeln Sie Text-Prompts kostenlos in filmische KI-Videos. Mit Veo 3.1, Sora 2, Kling & Seedance. Mehrere Seitenverhältnisse & Dauern. Jetzt WeryAI testen!',
            twitter_title: 'Kostenlose KI Text-zu-Video: Prompts zu Videos | WeryAI',
            twitter_description: 'Verwandeln Sie Text-Prompts kostenlos in filmische KI-Videos. Mit Veo 3.1, Sora 2, Kling & Seedance. Mehrere Seitenverhältnisse & Dauern. Jetzt WeryAI testen!',
            page: {
                title1: 'Kostenloser KI Text-zu-Video Generator',
                title2: 'Tippen Sie einfach einen Prompt ein und sehen Sie zu, wie WeryAI Ihre Idee zum Leben erweckt. Unser Text‑zu‑Video‑Generator bündelt modernste Modelle wie Google Veo 3.1 und Kling AI, sodass Sie in Sekunden hochwertige, physikalisch stimmige Videos für Social (9:16) oder Kino‑Projekte (16:9) erstellen können.',
                intro_title: 'Machen Sie Fantasie mit Text‑zu‑Video KI real',
                feature_title: 'Funktionen von WeryAI Text‑zu‑Video',
                faq_title: 'Häufige Fragen zu Text‑zu‑Video',
                feature_title1: 'Multi‑Model Power',
                feature_desc1: 'Wechseln Sie zwischen Veo 3.1 für Realismus und Kling für Bewegungs‑Konsistenz. Keine separaten Abos nötig.',
                feature_title2: 'Eigene Seitenverhältnisse',
                feature_desc2: 'Erzeugen Sie vertikale Videos (9:16) für TikTok/Reels oder 16:9 für YouTube direkt.',
                feature_title3: 'Längere Dauer',
                feature_desc3: 'Erstellen Sie Videos bis zu 8 Sekunden (oder länger mit Erweiterungen) in einer Generierung – ideal fürs Storytelling.',
                faq: [
                    {
                        question: 'Wie schreibe ich einen guten Prompt für Text‑zu‑Video?',
                        answer: 'Seien Sie konkret: Motiv, Aktion, Licht und Kamerawinkel. Beispiel: „Cineastische Drohnenaufnahme einer futuristischen Cyberpunk‑Stadt bei Nacht, Neonlichter, 4K".',
                    },
                    {
                        question: 'Welches Modell soll ich nutzen: Google Veo 3.1 oder Kling?',
                        answer: 'Google Veo 3.1 bietet starke Bildqualität und Prompt‑Treue, ideal für realistische Szenen. Kling AI ist oft besser bei komplexen Charakterbewegungen. Probieren Sie beide aus.',
                    },
                    {
                        question: 'Kann ich WeryAI Text‑zu‑Video kostenlos nutzen?',
                        answer: 'Ja! Neue Nutzer erhalten bei der Anmeldung Gratis‑Credits – keine Kreditkarte nötig. Zusätzlich können Sie täglich durch Check‑in, Aufgaben und Freundeseinladungen weitere Gratis‑Credits verdienen. Mit den Gratis‑Credits können Sie mehrere Clips erstellen und verschiedene Prompts und Modelle testen.',
                    },
                    {
                        question: 'Kann ich Videos länger als 8 Sekunden generieren?',
                        answer: 'Die Basis‑Generierung erstellt Clips bis zu 8 Sekunden (modellabhängig). Für längere Videos nutzen Sie unser AI Video Extender‑Tool, um nahtlos fortzusetzen.',
                    },
                    {
                        question: 'Haben die generierten Videos Ton?',
                        answer: 'Ja. Aktivieren Sie den „Generate Audio"-Schalter, um passende Soundeffekte und Ambiente automatisch zu erzeugen.',
                    },
                    {
                        question: 'Welche anderen KI-Videoerstellungsmethoden bietet WeryAI?',
                        answer: 'Neben Text‑zu‑Video bietet WeryAI <a href="/image-to-video">Image to Video</a> zum Animieren Ihrer Fotos und <a href="/video-to-video">Video to Video</a> zum Umgestalten bestehender Aufnahmen in Anime, 3D-Kunst oder Cyberpunk. Alle Tools teilen sich die gleichen täglichen Gratis-Credits.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Wie schreibe ich einen guten Prompt für Text‑zu‑Video?',
                    answer: 'Beschreiben Sie Motiv, Aktion, Licht und Kamera. Beispiel: „Cyberpunk‑Stadt bei Nacht, Neon, Drohne, 4K".',
                },
                {
                    question: 'Welches Modell soll ich nutzen: Google Veo 3.1 oder Kling?',
                    answer: 'Veo 3.1 ist stark bei Realismus/Prompt‑Treue, Kling bei Bewegungen. Testen Sie beide.',
                },
                {
                    question: 'Kann ich WeryAI Text‑zu‑Video kostenlos nutzen?',
                    answer: 'Ja! Gratis‑Credits bei der Anmeldung, ohne Kreditkarte. Verdienen Sie täglich weitere Credits durch Check‑in, Aufgaben und Freundeseinladungen, um fortlaufend Videos aus Text zu erstellen.',
                },
                {
                    question: 'Kann ich Videos länger als 8 Sekunden generieren?',
                    answer: 'Basis bis 8 Sekunden; für mehr Dauer nutzen Sie AI Video Extender.',
                },
                {
                    question: 'Haben die generierten Videos Ton?',
                    answer: 'Ja. Mit „Generate Audio" können Sie Audio automatisch erzeugen.',
                },
                {
                    question: 'Welche anderen KI-Videoerstellungsmethoden bietet WeryAI?',
                    answer: 'Neben Text‑zu‑Video bietet WeryAI Image to Video zum Animieren Ihrer Fotos und Video to Video zum Umgestalten bestehender Aufnahmen in Anime, 3D-Kunst oder Cyberpunk. Alle Tools teilen sich die gleichen täglichen Gratis-Credits.',
                },
            ],
        },
    },
    ru: {
        textToVideo: {
            title: 'Бесплатный AI Текст в Видео: Промпты в Видео | WeryAI',
            description: 'Превращайте текстовые промпты в кинематографичные AI-видео бесплатно. На базе Veo 3.1, Sora 2, Kling & Seedance. Разные форматы и длительности.',
            keywords: 'текст в видео ИИ, генератор текст в видео бесплатно, ИИ текст в видео, промпт в видео, txt2vid, видео из текста ИИ, текст в видео онлайн, WeryAI',
            og_title: 'Бесплатный AI Текст в Видео: Промпты в Видео | WeryAI',
            og_description: 'Превращайте текстовые промпты в кинематографичные AI-видео бесплатно. На базе Veo 3.1, Sora 2, Kling & Seedance. Разные форматы и длительности.',
            twitter_title: 'Бесплатный AI Текст в Видео: Промпты в Видео | WeryAI',
            twitter_description: 'Превращайте текстовые промпты в кинематографичные AI-видео бесплатно. На базе Veo 3.1, Sora 2, Kling & Seedance. Разные форматы и длительности.',
            page: {
                title1: 'Бесплатный AI Text‑to‑Video генератор',
                title2: 'Просто введите промпт — и WeryAI превратит идею в видео. Наш Text‑to‑Video агрегирует передовые модели вроде Google Veo 3.1 и Kling AI, позволяя создавать качественные, физически правдоподобные ролики для соцсетей (9:16) или кино‑формата (16:9) за секунды.',
                intro_title: 'Превратите воображение в реальность с Text‑to‑Video AI',
                feature_title: 'Возможности WeryAI Text‑to‑Video',
                faq_title: 'FAQ по Text‑to‑Video',
                feature_title1: 'Сила нескольких моделей',
                feature_desc1: 'Переключайтесь между Veo 3.1 для реализма и Kling для стабильного движения. Без множества подписок.',
                feature_title2: 'Нужное соотношение сторон',
                feature_desc2: 'Генерируйте вертикальные видео (9:16) для TikTok/Reels или 16:9 для YouTube напрямую.',
                feature_title3: 'Увеличенная длительность',
                feature_desc3: 'Создавайте видео до 8 секунд (или дольше с расширением) за одну генерацию — идеально для сторителлинга.',
                faq: [
                    {
                        question: 'Как написать хороший промпт для text‑to‑video?',
                        answer: 'Будьте конкретны: субъект, действие, свет и угол камеры. Пример: «Кинематографичный дрон‑шот футуристического киберпанк‑города ночью, неон, 4K».',
                    },
                    {
                        question: 'Что выбрать: Google Veo 3.1 или Kling?',
                        answer: 'Veo 3.1 даёт высокую детализацию и хорошее следование промпту, подходит для реалистичных сцен. Kling часто лучше для сложных движений персонажей. Рекомендуем попробовать оба.',
                    },
                    {
                        question: 'Можно ли использовать WeryAI Text‑to‑Video бесплатно?',
                        answer: 'Да! Новые пользователи получают бесплатные кредиты при регистрации — банковская карта не требуется. Вы также можете зарабатывать дополнительные бесплатные кредиты каждый день через ежедневную отметку, выполнение заданий и приглашение друзей. Бесплатные кредиты позволяют создавать несколько клипов для тестирования различных промптов и моделей.',
                    },
                    {
                        question: 'Можно ли делать видео длиннее 8 секунд?',
                        answer: 'Базовая генерация — до 8 секунд (зависит от модели). Для более длинных роликов используйте AI Video Extender, чтобы продолжить клип без швов.',
                    },
                    {
                        question: 'Будет ли звук в сгенерированных видео?',
                        answer: 'Да. Включите переключатель "Generate Audio", чтобы автоматически создать подходящие звуки и атмосферу.',
                    },
                    {
                        question: 'Какие ещё методы создания AI-видео предлагает WeryAI?',
                        answer: 'Помимо Text‑to‑Video, WeryAI предлагает <a href="/image-to-video">Image to Video</a> для анимации фотографий и <a href="/video-to-video">Video to Video</a> для перестилизации существующих видео в аниме, 3D или киберпанк. Все инструменты используют одни и те же ежедневные бесплатные кредиты.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Как написать хороший промпт для text‑to‑video?',
                    answer: 'Опишите субъект, действие, свет и камеру. Пример: «киберпанк‑город ночью, неон, дрон, 4K».',
                },
                {
                    question: 'Что выбрать: Google Veo 3.1 или Kling?',
                    answer: 'Veo 3.1 сильнее в реализме и следовании промпту, Kling — в движении. Протестируйте оба.',
                },
                {
                    question: 'Можно ли использовать WeryAI Text‑to‑Video бесплатно?',
                    answer: 'Да! Бесплатные кредиты при регистрации, без кредитной карты. Зарабатывайте ещё больше ежедневно через отметки, задания и приглашение друзей для непрерывного создания видео из текста.',
                },
                {
                    question: 'Можно ли делать видео длиннее 8 секунд?',
                    answer: 'База до 8 секунд; для большего используйте AI Video Extender.',
                },
                {
                    question: 'Будет ли звук в сгенерированных видео?',
                    answer: 'Да. Включите "Generate Audio" для автогенерации звука.',
                },
                {
                    question: 'Какие ещё методы создания AI-видео предлагает WeryAI?',
                    answer: 'Помимо Text‑to‑Video, WeryAI предлагает Image to Video для анимации фотографий и Video to Video для перестилизации существующих видео в аниме, 3D или киберпанк. Все инструменты используют одни и те же ежедневные бесплатные кредиты.',
                },
            ],
        },
    },
    pt: {
        textToVideo: {
            title: 'IA Texto para Vídeo Grátis: Prompts em Vídeos | WeryAI',
            description: 'Transforme prompts de texto em vídeos cinematográficos com IA grátis. Com Veo 3.1, Sora 2, Kling & Seedance. Múltiplos formatos e durações. Experimente WeryAI!',
            keywords: 'texto para vídeo IA, gerador texto para vídeo grátis, IA texto para vídeo, prompt para vídeo, txt2vid, vídeo IA de texto, texto para vídeo online, WeryAI',
            og_title: 'IA Texto para Vídeo Grátis: Prompts em Vídeos | WeryAI',
            og_description: 'Transforme prompts de texto em vídeos cinematográficos com IA grátis. Com Veo 3.1, Sora 2, Kling & Seedance. Múltiplos formatos e durações. Experimente WeryAI!',
            twitter_title: 'IA Texto para Vídeo Grátis: Prompts em Vídeos | WeryAI',
            twitter_description: 'Transforme prompts de texto em vídeos cinematográficos com IA grátis. Com Veo 3.1, Sora 2, Kling & Seedance. Múltiplos formatos e durações. Experimente WeryAI!',
            page: {
                title1: 'Gerador de IA de Texto para Vídeo Grátis',
                title2: 'Digite um prompt e veja a WeryAI dar vida à sua ideia. Nosso gerador Texto‑para‑Vídeo agrega modelos de ponta como Google Veo 3.1 e Kling AI, permitindo criar vídeos de alta qualidade e movimento natural para redes sociais (9:16) ou projetos cinematográficos (16:9) em segundos.',
                intro_title: 'Transforme imaginação em realidade com Texto‑para‑Vídeo',
                feature_title: 'Recursos do Texto para Vídeo da WeryAI',
                faq_title: 'Perguntas frequentes sobre Texto para Vídeo',
                feature_title1: 'Potência multi‑modelo',
                feature_desc1: 'Alterne entre Veo 3.1 para realismo e Kling para consistência de movimento. Sem várias assinaturas.',
                feature_title2: 'Proporções personalizadas',
                feature_desc2: 'Gere vídeos verticais (9:16) para TikTok/Reels ou 16:9 para YouTube diretamente.',
                feature_title3: 'Duração estendida',
                feature_desc3: 'Crie vídeos de até 8s (ou mais com extensões) em uma única geração — perfeito para storytelling.',
                faq: [
                    {
                        question: 'Como escrever um bom prompt de texto para vídeo?',
                        answer: 'Seja específico: sujeito, ação, iluminação e ângulo de câmera. Ex.: "Toma de drone cinematográfica de uma cidade cyberpunk futurista à noite, luzes neon, 4K".',
                    },
                    {
                        question: 'Qual modelo usar: Google Veo 3.1 ou Kling?',
                        answer: 'O Veo 3.1 oferece alta fidelidade visual e ótima aderência ao prompt, ideal para cenas realistas. O Kling costuma ir melhor em movimentos complexos de personagens. Recomendamos testar ambos.',
                    },
                    {
                        question: 'Posso usar o Texto para Vídeo da WeryAI de graça?',
                        answer: 'Sim! Novos usuários ganham créditos gratuitos ao se cadastrar — sem necessidade de cartão de crédito. Você também pode ganhar mais créditos gratuitos diariamente através de check-in diário, completando tarefas e convidando amigos. Os créditos gratuitos permitem criar vários clipes para testar diferentes prompts e modelos.',
                    },
                    {
                        question: 'Posso gerar vídeos com mais de 8 segundos?',
                        answer: 'A geração base cria clipes de até 8s (dependendo do modelo). Para vídeos mais longos, use o AI Video Extender para continuar o vídeo de forma contínua.',
                    },
                    {
                        question: 'Os vídeos gerados têm som?',
                        answer: 'Sim. Ative o toggle "Generate Audio" para criar automaticamente efeitos sonoros e ambiência.',
                    },
                    {
                        question: 'Quais outros métodos de criação de vídeo com IA a WeryAI oferece?',
                        answer: 'Além de Texto para Vídeo, a WeryAI oferece <a href="/image-to-video">Image to Video</a> para animar suas fotos e <a href="/video-to-video">Video to Video</a> para transformar vídeos existentes em anime, arte 3D ou cyberpunk. Todas as ferramentas compartilham os mesmos créditos diários gratuitos.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Como escrever um bom prompt de texto para vídeo?',
                    answer: 'Descreva sujeito, ação, luz e câmera. Ex.: "cidade cyberpunk à noite, neon, drone, 4K".',
                },
                {
                    question: 'Qual modelo usar: Google Veo 3.1 ou Kling?',
                    answer: 'Veo 3.1 é forte em realismo e aderência; Kling em movimento. Teste ambos.',
                },
                {
                    question: 'Posso usar o Texto para Vídeo da WeryAI de graça?',
                    answer: 'Sim! Créditos gratuitos no cadastro, sem cartão de crédito. Ganhe mais créditos todos os dias via check-in, tarefas e convite de amigos para continuar criando vídeos a partir de texto.',
                },
                {
                    question: 'Posso gerar vídeos com mais de 8 segundos?',
                    answer: 'Base até 8s; para mais duração, use AI Video Extender.',
                },
                {
                    question: 'Os vídeos gerados têm som?',
                    answer: 'Sim. Ative "Generate Audio" para gerar som automaticamente.',
                },
                {
                    question: 'Quais outros métodos de criação de vídeo com IA a WeryAI oferece?',
                    answer: 'Além de Texto para Vídeo, a WeryAI oferece Image to Video para animar suas fotos e Video to Video para transformar vídeos existentes em anime, arte 3D ou cyberpunk. Todas as ferramentas compartilham os mesmos créditos diários gratuitos.',
                },
            ],
        },
    },
    it: {
        textToVideo: {
            title: 'IA Testo a Video Gratis: Prompt in Video | WeryAI',
            description: 'Trasforma prompt di testo in video cinematografici con IA gratis. Con Veo 3.1, Sora 2, Kling & Seedance. Più formati e durate. Prova WeryAI ora!',
            keywords: 'testo a video IA, generatore testo video gratis, IA testo a video, prompt a video, txt2vid, video IA da testo, testo a video online, WeryAI',
            og_title: 'IA Testo a Video Gratis: Prompt in Video | WeryAI',
            og_description: 'Trasforma prompt di testo in video cinematografici con IA gratis. Con Veo 3.1, Sora 2, Kling & Seedance. Più formati e durate. Prova WeryAI ora!',
            twitter_title: 'IA Testo a Video Gratis: Prompt in Video | WeryAI',
            twitter_description: 'Trasforma prompt di testo in video cinematografici con IA gratis. Con Veo 3.1, Sora 2, Kling & Seedance. Più formati e durate. Prova WeryAI ora!',
            page: {
                title1: 'Generatore IA da Testo a Video Gratis',
                title2: 'Scrivi un prompt e guarda WeryAI dare vita alla tua idea. Il nostro Text‑to‑Video aggrega modelli all\'avanguardia come Google Veo 3.1 e Kling AI, permettendoti di creare video di alta qualità e fisicamente coerenti per social (9:16) o progetti cinematografici (16:9) in pochi secondi.',
                intro_title: 'Trasforma l\'immaginazione in realtà con Text‑to‑Video',
                feature_title: 'Funzioni di WeryAI Text‑to‑Video',
                faq_title: 'Domande frequenti su Text‑to‑Video',
                feature_title1: 'Potenza multi‑modello',
                feature_desc1: 'Passa da Veo 3.1 per il realismo a Kling per la coerenza del movimento. Niente abbonamenti multipli.',
                feature_title2: 'Rapporti personalizzati',
                feature_desc2: 'Genera video verticali (9:16) per TikTok/Reels o 16:9 per YouTube direttamente.',
                feature_title3: 'Durata estesa',
                feature_desc3: 'Crea video fino a 8s (o più con estensioni) in una sola generazione, perfetto per storytelling.',
                faq: [
                    {
                        question: 'Come scrivo un buon prompt per il text‑to‑video?',
                        answer: 'Sii specifico: soggetto, azione, luce e angolo camera. Esempio: "Ripresa drone cinematografica di una città cyberpunk futuristica di notte, luci al neon, 4K".',
                    },
                    {
                        question: 'Quale modello usare: Google Veo 3.1 o Kling?',
                        answer: 'Google Veo 3.1 offre grande fedeltà visiva e aderenza al prompt, ideale per scene realistiche. Kling spesso rende meglio con movimenti complessi dei personaggi. Consigliamo di provarli entrambi.',
                    },
                    {
                        question: 'Posso usare WeryAI Text‑to‑Video gratuitamente?',
                        answer: 'Sì! I nuovi utenti ricevono crediti gratuiti alla registrazione, senza carta di credito. Puoi anche guadagnare più crediti gratuiti ogni giorno tramite check-in giornaliero, completamento di attività e inviti agli amici. I crediti gratuiti ti permettono di creare più clip per testare diversi prompt e modelli.',
                    },
                    {
                        question: 'Posso generare video più lunghi di 8 secondi?',
                        answer: 'La generazione base crea clip fino a 8s (a seconda del modello). Per video più lunghi, usa il nostro AI Video Extender per continuare la scena senza stacchi.',
                    },
                    {
                        question: 'I video generati hanno audio?',
                        answer: 'Sì. Puoi attivare l\'opzione "Generate Audio" per creare automaticamente effetti sonori e ambience.',
                    },
                    {
                        question: 'Quali altri metodi di creazione video IA offre WeryAI?',
                        answer: 'Oltre al Text‑to‑Video, WeryAI offre <a href="/image-to-video">Image to Video</a> per animare le tue foto e <a href="/video-to-video">Video to Video</a> per trasformare filmati esistenti in anime, arte 3D o cyberpunk. Tutti gli strumenti condividono gli stessi crediti giornalieri gratuiti.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Come scrivo un buon prompt per il text‑to‑video?',
                    answer: 'Descrivi soggetto, azione, luce e camera. Esempio: "città cyberpunk di notte, neon, drone, 4K".',
                },
                {
                    question: 'Quale modello usare: Google Veo 3.1 o Kling?',
                    answer: 'Veo 3.1 è forte in realismo/aderenza; Kling in movimento. Prova entrambi.',
                },
                {
                    question: 'Posso usare WeryAI Text‑to‑Video gratuitamente?',
                    answer: 'Sì! Crediti gratuiti alla registrazione, senza carta di credito. Guadagna altri crediti ogni giorno con check-in, attività e inviti amici per continuare a creare video dal testo.',
                },
                {
                    question: 'Posso generare video più lunghi di 8 secondi?',
                    answer: 'Base fino a 8s; per più durata usa AI Video Extender.',
                },
                {
                    question: 'I video generati hanno audio?',
                    answer: 'Sì. Attiva "Generate Audio" per generare l\'audio automaticamente.',
                },
                {
                    question: 'Quali altri metodi di creazione video IA offre WeryAI?',
                    answer: 'Oltre al Text‑to‑Video, WeryAI offre Image to Video per animare le tue foto e Video to Video per trasformare filmati esistenti in anime, arte 3D o cyberpunk. Tutti gli strumenti condividono gli stessi crediti giornalieri gratuiti.',
                },
            ],
        },
    },
    ar: {
        textToVideo: {
            title: 'تحويل النص إلى فيديو بالذكاء الاصطناعي مجانًا | WeryAI',
            description: 'حوّل النصوص إلى فيديوهات سينمائية بالذكاء الاصطناعي مجانًا. بدعم Veo 3.1 وSora 2 وKling وSeedance. نسب ومُدد متعددة. جرّب WeryAI الآن!',
            keywords: 'تحويل النص إلى فيديو, مولد فيديو ذكاء اصطناعي مجاني, نص إلى فيديو AI, prompt إلى فيديو, txt2vid, فيديو من نص, تحويل نص لفيديو أونلاين, WeryAI',
            og_title: 'تحويل النص إلى فيديو بالذكاء الاصطناعي مجانًا | WeryAI',
            og_description: 'حوّل النصوص إلى فيديوهات سينمائية بالذكاء الاصطناعي مجانًا. بدعم Veo 3.1 وSora 2 وKling وSeedance. نسب ومُدد متعددة. جرّب WeryAI الآن!',
            twitter_title: 'تحويل النص إلى فيديو بالذكاء الاصطناعي مجانًا | WeryAI',
            twitter_description: 'حوّل النصوص إلى فيديوهات سينمائية بالذكاء الاصطناعي مجانًا. بدعم Veo 3.1 وSora 2 وKling وSeedance. نسب ومُدد متعددة. جرّب WeryAI الآن!',
            page: {
                title1: 'مولّد تحويل النص إلى فيديو بالذكاء الاصطناعي مجانًا',
                title2: 'اكتب مطالبة نصية وشاهد WeryAI يحوّل فكرتك إلى فيديو. تجمع أداة تحويل النص إلى فيديو لدينا نماذج متقدمة مثل Google Veo 3.1 وKling AI، لتمنحك فيديوهات عالية الجودة ومتسقة فيزيائيًا لمقاطع السوشيال العمودية (9:16) أو المشاريع السينمائية (16:9) خلال ثوانٍ.',
                intro_title: 'حوّل الخيال إلى واقع مع تحويل النص إلى فيديو',
                feature_title: 'ميزات تحويل النص إلى فيديو من WeryAI',
                faq_title: 'الأسئلة الشائعة حول تحويل النص إلى فيديو',
                feature_title1: 'قوة متعددة النماذج',
                feature_desc1: 'بدّل بين Veo 3.1 للواقعية وKling لاتساق الحركة — بدون الحاجة لاشتراكات متعددة.',
                feature_title2: 'نِسَب عرض مخصصة',
                feature_desc2: 'أنشئ فيديوهات عمودية (9:16) لـ TikTok/Reels أو أفقية (16:9) لـ YouTube مباشرة.',
                feature_title3: 'مدة أطول',
                feature_desc3: 'أنشئ فيديوهات حتى 8 ثوانٍ (أو أطول عبر أدوات التمديد) في توليد واحد — مثالي للسرد القصصي.',
                faq: [
                    {
                        question: 'كيف أكتب مطالبة جيدة لتحويل النص إلى فيديو؟',
                        answer: 'كن محددًا: صف الموضوع والحركة والإضاءة وزاوية الكاميرا. مثال: "لقطة درون سينمائية لمدينة سايبربانك مستقبلية ليلًا، أضواء نيون، 4K".',
                    },
                    {
                        question: 'أي نموذج أختار: Google Veo 3.1 أم Kling؟',
                        answer: 'يتميز Veo 3.1 بجودة بصرية عالية والالتزام بالمطالبة، وهو مناسب للمشاهد الواقعية. غالبًا ما يكون Kling أفضل في حركات الشخصيات المعقدة. ننصح بتجربة الاثنين.',
                    },
                    {
                        question: 'هل يمكنني استخدام تحويل النص إلى فيديو في WeryAI مجاناً؟',
                        answer: 'نعم! يحصل المستخدمون الجدد على رصيد مجاني عند التسجيل، بدون الحاجة لبطاقة ائتمان. يمكنك أيضًا كسب المزيد من الأرصدة المجانية يوميًا من خلال تسجيل الدخول اليومي وإتمام المهام ودعوة الأصدقاء. تتيح لك الأرصدة المجانية إنشاء عدة مقاطع لاختبار مطالبات ونماذج مختلفة.',
                    },
                    {
                        question: 'هل يمكنني إنشاء فيديو أطول من 8 ثوانٍ؟',
                        answer: 'التوليد الأساسي يصل حتى 8 ثوانٍ (حسب النموذج). لمقاطع أطول، استخدم أداة AI Video Extender لمتابعة الفيديو بسلاسة.',
                    },
                    {
                        question: 'هل تحتوي الفيديوهات المُولَّدة على صوت؟',
                        answer: 'نعم. يمكنك تفعيل خيار "Generate Audio" لإنشاء مؤثرات صوتية وأجواء خلفية تلقائيًا.',
                    },
                    {
                        question: 'ما طرق إنشاء فيديو AI الأخرى التي يقدمها WeryAI؟',
                        answer: 'إلى جانب تحويل النص إلى فيديو، يقدم WeryAI <a href="/image-to-video">Image to Video</a> لتحريك صورك و<a href="/video-to-video">Video to Video</a> لتحويل لقطات موجودة إلى أنيمي أو فن ثلاثي الأبعاد أو سايبربانك. تتشارك جميع الأدوات نفس الأرصدة المجانية اليومية.',
                    },
                ],
            },
            faq: [
                {
                    question: 'كيف أكتب مطالبة جيدة لتحويل النص إلى فيديو؟',
                    answer: 'صف الموضوع والحركة والإضاءة والكاميرا بوضوح. مثال: "مدينة سايبربانك ليلًا، نيون، درون، 4K".',
                },
                {
                    question: 'أي نموذج أختار: Google Veo 3.1 أم Kling؟',
                    answer: 'Veo 3.1 قوي في الواقعية والالتزام، وKling قوي في الحركة. جرّب الاثنين.',
                },
                {
                    question: 'هل يمكنني استخدام تحويل النص إلى فيديو في WeryAI مجاناً؟',
                    answer: 'نعم! أرصدة مجانية عند التسجيل، بدون بطاقة ائتمان. اكسب المزيد يوميًا عبر تسجيل الدخول والمهام ودعوة الأصدقاء لمواصلة إنشاء الفيديوهات من النص.',
                },
                {
                    question: 'هل يمكنني إنشاء فيديو أطول من 8 ثوانٍ؟',
                    answer: 'الأساسي حتى 8 ثوانٍ؛ للمدة الأطول استخدم AI Video Extender.',
                },
                {
                    question: 'هل تحتوي الفيديوهات المُولَّدة على صوت؟',
                    answer: 'نعم. فعّل "Generate Audio" لتوليد الصوت تلقائيًا.',
                },
                {
                    question: 'ما طرق إنشاء فيديو AI الأخرى التي يقدمها WeryAI؟',
                    answer: 'إلى جانب تحويل النص إلى فيديو، يقدم WeryAI أداة Image to Video لتحريك صورك وVideo to Video لتحويل لقطات موجودة إلى أنيمي أو فن ثلاثي الأبعاد أو سايبربانك. تتشارك جميع الأدوات نفس الأرصدة المجانية اليومية.',
                },
            ],
        },
    },
    tw: {
        textToVideo: {
            title: '免費 AI 文生影片：提示詞一鍵生成影片 | WeryAI',
            description: '免費將文字提示詞轉成電影感 AI 影片。由 Veo 3.1、Sora 2、Kling 和 Seedance 驅動，支援多種比例與時長。立即體驗 WeryAI！',
            keywords: '文生影片, AI 文字轉影片, 免費文生影片, 提示詞生成影片, txt2vid, AI 影片產生器, 線上文生影片, WeryAI',
            og_title: '免費 AI 文生影片：提示詞一鍵生成影片 | WeryAI',
            og_description: '免費將文字提示詞轉成電影感 AI 影片。由 Veo 3.1、Sora 2、Kling 和 Seedance 驅動，支援多種比例與時長。立即體驗 WeryAI！',
            twitter_title: '免費 AI 文生影片：提示詞一鍵生成影片 | WeryAI',
            twitter_description: '免費將文字提示詞轉成電影感 AI 影片。由 Veo 3.1、Sora 2、Kling 和 Seedance 驅動，支援多種比例與時長。立即體驗 WeryAI！',
            page: {
                title1: '免費 AI 文生影片生成器',
                title2: '只要輸入提示詞，WeryAI 就能讓你的想法成形。我們的文生影片生成器整合 Google Veo 3.1、Kling AI 等頂尖模型，讓你在數秒內產生高品質、符合物理一致性的影片，適用於社群直式（9:16）或電影感橫式（16:9）。',
                intro_title: '用文生影片 AI 把想像變成現實',
                feature_title: 'WeryAI 文生影片功能特色',
                faq_title: '文生影片常見問題',
                feature_title1: '多模型強力整合',
                feature_desc1: '可在 Veo 3.1 的真實感與 Kling 的動作一致性之間切換，無需多重訂閱。',
                feature_title2: '自訂畫面比例',
                feature_desc2: '直接生成 TikTok/Reels 的直式 9:16 或 YouTube 的橫式 16:9。',
                feature_title3: '延長生成時長',
                feature_desc3: '單次生成最長 8 秒（或使用延長工具產生更長片段），適合敘事創作。',
                faq: [
                    {
                        question: '如何寫出好的文生影片提示詞？',
                        answer: '要具體描述主體、動作、光線與鏡頭角度。例如：「夜晚未來賽博龐克城市的電影感空拍，霓虹燈，4K。」WeryAI 的整合模型能理解複雜描述。',
                    },
                    {
                        question: '該選 Google Veo 3.1 還是 Kling？',
                        answer: 'Veo 3.1 具備更高畫質與提示詞遵循度，適合寫實場景；Kling 通常在複雜角色動作上更好。建議兩者都試試。',
                    },
                    {
                        question: 'WeryAI 文生影片可以免費使用嗎？',
                        answer: '是的！新使用者註冊即可獲得免費點數，無需綁定信用卡。還可透過每日簽到、完成任務和邀請好友持續獲得更多免費點數，盡情體驗文生影片創作。',
                    },
                    {
                        question: '可以生成超過 8 秒的影片嗎？',
                        answer: '基礎生成最長 8 秒（視模型而定）。若需要更長影片，可使用 AI 影片延長工具無縫續接。',
                    },
                    {
                        question: '生成的影片有聲音嗎？',
                        answer: '可以，開啟工具中的「Generate Audio」即可自動產生符合畫面的音效與環境聲。',
                    },
                    {
                        question: 'WeryAI 還提供哪些 AI 影片創作方式？',
                        answer: '除了文生影片，WeryAI 還提供 <a href="/image-to-video">Image to Video</a>（將照片動畫化）和 <a href="/video-to-video">Video to Video</a>（將現有影片轉換為動漫、3D 或賽博龐克風格）。所有工具共享每日免費點數。',
                    },
                ],
            },
            faq: [
                {
                    question: '如何寫出好的文生影片提示詞？',
                    answer: '要具體描述主體、動作、光線與鏡頭角度。例如：「夜晚未來賽博龐克城市的電影感空拍，霓虹燈，4K。」WeryAI 的整合模型能理解複雜描述。',
                },
                {
                    question: '該選 Google Veo 3.1 還是 Kling？',
                    answer: 'Veo 3.1 具備更高畫質與提示詞遵循度，適合寫實場景；Kling 通常在複雜角色動作上更好。建議兩者都試試。',
                },
                {
                    question: 'WeryAI 文生影片可以免費使用嗎？',
                    answer: '是的！新使用者註冊即可獲得免費點數，無需綁定信用卡。還可透過每日簽到、完成任務和邀請好友持續獲得更多免費點數，盡情體驗文生影片創作。',
                },
                {
                    question: '可以生成超過 8 秒的影片嗎？',
                    answer: '基礎生成最長 8 秒（視模型而定）。若需要更長影片，可使用 AI 影片延長工具無縫續接。',
                },
                {
                    question: '生成的影片有聲音嗎？',
                    answer: '可以，開啟工具中的「Generate Audio」即可自動產生符合畫面的音效與環境聲。',
                },
                {
                    question: 'WeryAI 還提供哪些 AI 影片創作方式？',
                    answer: '除了文生影片，WeryAI 還提供 Image to Video（將照片動畫化）和 Video to Video（將現有影片轉換為動漫、3D 或賽博龐克風格）。所有工具共享每日免費點數。',
                },
            ],
        },
    },
    pl: {
        textToVideo: {
            title: 'Darmowa AI Tekst na Wideo: Prompty w Filmy | WeryAI',
            description: 'Zamień prompty tekstowe w filmowe wideo AI za darmo. Z Veo 3.1, Sora 2, Kling i Seedance. Różne proporcje i czasy trwania. Wypróbuj WeryAI!',
            keywords: 'tekst na wideo AI, darmowy generator tekst na wideo, AI tekst na wideo, prompt na wideo, txt2vid, wideo AI z tekstu, tekst na wideo online, WeryAI',
            og_title: 'Darmowa AI Tekst na Wideo: Prompty w Filmy | WeryAI',
            og_description: 'Zamień prompty tekstowe w filmowe wideo AI za darmo. Z Veo 3.1, Sora 2, Kling i Seedance. Różne proporcje i czasy trwania. Wypróbuj WeryAI!',
            twitter_title: 'Darmowa AI Tekst na Wideo: Prompty w Filmy | WeryAI',
            twitter_description: 'Zamień prompty tekstowe w filmowe wideo AI za darmo. Z Veo 3.1, Sora 2, Kling i Seedance. Różne proporcje i czasy trwania. Wypróbuj WeryAI!',
            page: {
                title1: 'Darmowy generator AI tekst→wideo',
                title2: 'Wpisz prompt i zobacz, jak WeryAI ożywia Twój pomysł. Nasz generator tekst→wideo agreguje najnowsze modele, takie jak Google Veo 3.1 i Kling AI, pozwalając tworzyć wysokiej jakości, fizycznie spójne filmy dla social mediów (9:16) lub projektów kinowych (16:9) w kilka sekund.',
                intro_title: 'Zamień wyobraźnię w rzeczywistość dzięki AI tekst→wideo',
                feature_title: 'Funkcje WeryAI tekst→wideo',
                faq_title: 'Najczęstsze pytania o tekst→wideo',
                feature_title1: 'Moc wielu modeli',
                feature_desc1: 'Przełączaj się między Veo 3.1 dla realizmu a Kling dla spójności ruchu. Bez wielu subskrypcji.',
                feature_title2: 'Niestandardowe proporcje',
                feature_desc2: 'Generuj pionowe wideo (9:16) na TikToka/Reels lub szeroki kadr (16:9) na YouTube bezpośrednio.',
                feature_title3: 'Wydłużony czas',
                feature_desc3: 'Twórz filmy do 8 sekund (lub dłuższe z rozszerzeniami) w jednym generowaniu — idealne do opowiadania historii.',
                faq: [
                    {
                        question: 'Jak napisać dobry prompt do AI tekst→wideo?',
                        answer: 'Bądź konkretny: opisz temat, akcję, światło i kąt kamery. Np.: "Filmowe ujęcie dronem futurystycznego miasta cyberpunkowego nocą, neony, 4K". Zintegrowane modele WeryAI dobrze rozumieją złożone opisy.',
                    },
                    {
                        question: 'Który model wybrać: Google Veo 3.1 czy Kling?',
                        answer: 'Veo 3.1 zapewnia świetną jakość obrazu i zgodność z promptem, idealny do realistycznych scen. Kling AI często lepiej radzi sobie z złożonym ruchem postaci. Warto przetestować oba.',
                    },
                    {
                        question: 'Czy mogę korzystać z WeryAI tekst→wideo za darmo?',
                        answer: 'Tak! Nowi użytkownicy otrzymują darmowe kredyty przy rejestracji — karta kredytowa nie jest wymagana. Możesz też zdobywać więcej darmowych kredytów każdego dnia przez codzienne logowanie, realizację zadań i zapraszanie znajomych. Darmowe kredyty pozwalają tworzyć wiele klipów, aby testować różne prompty i modele.',
                    },
                    {
                        question: 'Czy mogę generować filmy dłuższe niż 8 sekund?',
                        answer: 'Podstawowa generacja tworzy klipy do 8 s (zależnie od modelu). Aby uzyskać dłuższe wideo, użyj narzędzia AI Video Extender, które płynnie kontynuuje ujęcie.',
                    },
                    {
                        question: 'Czy wygenerowane wideo ma dźwięk?',
                        answer: 'Tak, możesz włączyć przełącznik "Generate Audio" (w narzędziu), aby automatycznie tworzyć pasujące efekty dźwiękowe i tło.',
                    },
                    {
                        question: 'Jakie inne metody tworzenia wideo AI oferuje WeryAI?',
                        answer: 'Oprócz tekstu na wideo, WeryAI oferuje <a href="/image-to-video">Image to Video</a> do animowania zdjęć oraz <a href="/video-to-video">Video to Video</a> do przekształcania istniejących nagrań w anime, sztukę 3D lub cyberpunk. Wszystkie narzędzia korzystają z tych samych darmowych dziennych kredytów.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Jak napisać dobry prompt do AI tekst→wideo?',
                    answer: 'Bądź konkretny: opisz temat, akcję, światło i kąt kamery. Np.: "Filmowe ujęcie dronem futurystycznego miasta cyberpunkowego nocą, neony, 4K". Zintegrowane modele WeryAI dobrze rozumieją złożone opisy.',
                },
                {
                    question: 'Który model wybrać: Google Veo 3.1 czy Kling?',
                    answer: 'Veo 3.1 zapewnia świetną jakość obrazu i zgodność z promptem, idealny do realistycznych scen. Kling AI często lepiej radzi sobie z złożonym ruchem postaci. Warto przetestować oba.',
                },
                {
                    question: 'Czy mogę korzystać z WeryAI tekst→wideo za darmo?',
                    answer: 'Tak! Nowi użytkownicy otrzymują darmowe kredyty przy rejestracji — karta kredytowa nie jest wymagana. Możesz też zdobywać więcej darmowych kredytów każdego dnia przez codzienne logowanie, realizację zadań i zapraszanie znajomych. Darmowe kredyty pozwalają tworzyć wiele klipów, aby testować różne prompty i modele.',
                },
                {
                    question: 'Czy mogę generować filmy dłuższe niż 8 sekund?',
                    answer: 'Podstawowa generacja tworzy klipy do 8 s (zależnie od modelu). Aby uzyskać dłuższe wideo, użyj narzędzia AI Video Extender, które płynnie kontynuuje ujęcie.',
                },
                {
                    question: 'Czy wygenerowane wideo ma dźwięk?',
                    answer: 'Tak, możesz włączyć przełącznik "Generate Audio" (w narzędziu), aby automatycznie tworzyć pasujące efekty dźwiękowe i tło.',
                },
                {
                    question: 'Jakie inne metody tworzenia wideo AI oferuje WeryAI?',
                    answer: 'Oprócz tekstu na wideo, WeryAI oferuje Image to Video do animowania zdjęć oraz Video to Video do przekształcania istniejących nagrań w anime, sztukę 3D lub cyberpunk. Wszystkie narzędzia korzystają z tych samych darmowych dziennych kredytów.',
                },
            ],
        },
    },
    th: {
        textToVideo: {
            title: 'AI แปลงข้อความเป็นวิดีโอฟรี: พรอมต์สู่วิดีโอ | WeryAI',
            description: 'แปลงข้อความเป็นวิดีโอ AI สไตล์ภาพยนตร์ฟรี ขับเคลื่อนด้วย Veo 3.1, Sora 2, Kling & Seedance รองรับหลายอัตราส่วนและความยาว ลอง WeryAI เลย!',
            keywords: 'ข้อความเป็นวิดีโอ AI, แปลงข้อความเป็นวิดีโอฟรี, AI ข้อความสู่วิดีโอ, พรอมต์เป็นวิดีโอ, txt2vid, วิดีโอ AI จากข้อความ, แปลงข้อความเป็นวิดีโอออนไลน์, WeryAI',
            og_title: 'AI แปลงข้อความเป็นวิดีโอฟรี: พรอมต์สู่วิดีโอ | WeryAI',
            og_description: 'แปลงข้อความเป็นวิดีโอ AI สไตล์ภาพยนตร์ฟรี ขับเคลื่อนด้วย Veo 3.1, Sora 2, Kling & Seedance รองรับหลายอัตราส่วนและความยาว ลอง WeryAI เลย!',
            twitter_title: 'AI แปลงข้อความเป็นวิดีโอฟรี: พรอมต์สู่วิดีโอ | WeryAI',
            twitter_description: 'แปลงข้อความเป็นวิดีโอ AI สไตล์ภาพยนตร์ฟรี ขับเคลื่อนด้วย Veo 3.1, Sora 2, Kling & Seedance รองรับหลายอัตราส่วนและความยาว ลอง WeryAI เลย!',
            page: {
                title1: 'เครื่องมือสร้างวิดีโอจากข้อความด้วย AI ฟรี',
                title2: 'เพียงพิมพ์พรอมต์ แล้ว WeryAI จะทำให้ไอเดียของคุณมีชีวิต เครื่องมือข้อความเป็นวิดีโอของเรารวมโมเดลล้ำสมัยอย่าง Google Veo 3.1 และ Kling AI ให้คุณสร้างวิดีโอคุณภาพสูงที่สมจริงทางกายภาพสำหรับโซเชียลมีเดียแนวตั้ง (9:16) หรือโปรเจกต์แบบภาพยนตร์ (16:9) ได้ภายในไม่กี่วินาที',
                intro_title: 'เปลี่ยนจินตนาการให้เป็นจริงด้วย AI ข้อความเป็นวิดีโอ',
                feature_title: 'ฟีเจอร์ของ WeryAI ข้อความเป็นวิดีโอ',
                faq_title: 'คำถามที่พบบ่อยเกี่ยวกับข้อความเป็นวิดีโอ',
                feature_title1: 'พลังหลายโมเดล',
                feature_desc1: 'สลับระหว่าง Veo 3.1 เพื่อความสมจริง และ Kling เพื่อความต่อเนื่องของการเคลื่อนไหว ไม่ต้องสมัครหลายบริการ',
                feature_title2: 'อัตราส่วนภาพตามต้องการ',
                feature_desc2: 'สร้างวิดีโอแนวตั้ง (9:16) สำหรับ TikTok/Reels หรือแนวนอน (16:9) สำหรับ YouTube ได้ทันที',
                feature_title3: 'ความยาววิดีโอมากขึ้น',
                feature_desc3: 'สร้างวิดีโอได้สูงสุด 8 วินาที (หรือยาวกว่านั้นด้วยเครื่องมือขยาย) ในการสร้างครั้งเดียว เหมาะกับการเล่าเรื่อง',
                faq: [
                    {
                        question: 'จะเขียนพรอมต์ให้ดีสำหรับ AI ข้อความเป็นวิดีโอได้อย่างไร?',
                        answer: 'ระบุให้ชัดเจนทั้งตัวแบบ การกระทำ แสง และมุมกล้อง เช่น "ภาพโดรนสไตล์ภาพยนตร์ของเมืองไซเบอร์พังก์ในตอนกลางคืน แสงนีออน ความละเอียด 4K" โมเดลที่รวมใน WeryAI เข้าใจคำบรรยายที่ซับซ้อนได้ดี',
                    },
                    {
                        question: 'ควรใช้โมเดลไหน: Google Veo 3.1 หรือ Kling?',
                        answer: 'Veo 3.1 ให้ความคมชัดสูงและตรงตามพรอมต์ เหมาะกับฉากสมจริง ส่วน Kling มักทำได้ดีกว่าสำหรับการเคลื่อนไหวตัวละครที่ซับซ้อน แนะนำให้ลองทั้งสองแบบ',
                    },
                    {
                        question: 'ใช้ WeryAI ข้อความเป็นวิดีโอได้ฟรีไหม?',
                        answer: 'ใช่! ผู้ใช้ใหม่ได้รับเครดิตฟรีเมื่อสมัครสมาชิก ไม่ต้องใช้บัตรเครดิต คุณยังสามารถรับเครดิตฟรีเพิ่มเติมได้ทุกวันผ่านการเช็คอินรายวัน ทำภารกิจ และเชิญเพื่อน เครดิตฟรีช่วยให้คุณสร้างหลายคลิปเพื่อทดสอบพรอมต์และโมเดลต่างๆ ได้',
                    },
                    {
                        question: 'สามารถสร้างวิดีโอที่ยาวกว่า 8 วินาทีได้ไหม?',
                        answer: 'การสร้างพื้นฐานทำได้สูงสุด 8 วินาที (ขึ้นอยู่กับโมเดล) หากต้องการวิดีโอยาวขึ้น สามารถใช้เครื่องมือ AI Video Extender เพื่อขยายต่อเนื่องได้',
                    },
                    {
                        question: 'วิดีโอที่สร้างมีเสียงไหม?',
                        answer: 'มี คุณสามารถเปิดสวิตช์ "Generate Audio" (ในเครื่องมือ) เพื่อให้ระบบสร้างเอฟเฟกต์เสียงและบรรยากาศที่เข้ากันโดยอัตโนมัติ',
                    },
                    {
                        question: 'WeryAI มีวิธีสร้างวิดีโอ AI แบบอื่นอีกไหม?',
                        answer: 'นอกจากข้อความเป็นวิดีโอ WeryAI ยังมี <a href="/image-to-video">Image to Video</a> สำหรับทำให้ภาพถ่ายเคลื่อนไหว และ <a href="/video-to-video">Video to Video</a> สำหรับเปลี่ยนสไตล์วิดีโอที่มีอยู่เป็นอนิเมะ 3D หรือไซเบอร์พังก์ เครื่องมือทั้งหมดใช้เครดิตฟรีรายวันร่วมกัน',
                    },
                ],
            },
            faq: [
                {
                    question: 'จะเขียนพรอมต์ให้ดีสำหรับ AI ข้อความเป็นวิดีโอได้อย่างไร?',
                    answer: 'ระบุให้ชัดเจนทั้งตัวแบบ การกระทำ แสง และมุมกล้อง เช่น "ภาพโดรนสไตล์ภาพยนตร์ของเมืองไซเบอร์พังก์ในตอนกลางคืน แสงนีออน ความละเอียด 4K" โมเดลที่รวมใน WeryAI เข้าใจคำบรรยายที่ซับซ้อนได้ดี',
                },
                {
                    question: 'ควรใช้โมเดลไหน: Google Veo 3.1 หรือ Kling?',
                    answer: 'Veo 3.1 ให้ความคมชัดสูงและตรงตามพรอมต์ เหมาะกับฉากสมจริง ส่วน Kling มักทำได้ดีกว่าสำหรับการเคลื่อนไหวตัวละครที่ซับซ้อน แนะนำให้ลองทั้งสองแบบ',
                },
                {
                    question: 'ใช้ WeryAI ข้อความเป็นวิดีโอได้ฟรีไหม?',
                    answer: 'ใช่! ผู้ใช้ใหม่ได้รับเครดิตฟรีเมื่อสมัครสมาชิก ไม่ต้องใช้บัตรเครดิต คุณยังสามารถรับเครดิตฟรีเพิ่มเติมได้ทุกวันผ่านการเช็คอินรายวัน ทำภารกิจ และเชิญเพื่อน เครดิตฟรีช่วยให้คุณสร้างหลายคลิปเพื่อทดสอบพรอมต์และโมเดลต่างๆ ได้',
                },
                {
                    question: 'สามารถสร้างวิดีโอที่ยาวกว่า 8 วินาทีได้ไหม?',
                    answer: 'การสร้างพื้นฐานทำได้สูงสุด 8 วินาที (ขึ้นอยู่กับโมเดล) หากต้องการวิดีโอยาวขึ้น สามารถใช้เครื่องมือ AI Video Extender เพื่อขยายต่อเนื่องได้',
                },
                {
                    question: 'วิดีโอที่สร้างมีเสียงไหม?',
                    answer: 'มี คุณสามารถเปิดสวิตช์ "Generate Audio" (ในเครื่องมือ) เพื่อให้ระบบสร้างเอฟเฟกต์เสียงและบรรยากาศที่เข้ากันโดยอัตโนมัติ',
                },
                {
                    question: 'WeryAI มีวิธีสร้างวิดีโอ AI แบบอื่นอีกไหม?',
                    answer: 'นอกจากข้อความเป็นวิดีโอ WeryAI ยังมี Image to Video สำหรับทำให้ภาพถ่ายเคลื่อนไหว และ Video to Video สำหรับเปลี่ยนสไตล์วิดีโอที่มีอยู่เป็นอนิเมะ 3D หรือไซเบอร์พังก์ เครื่องมือทั้งหมดใช้เครดิตฟรีรายวันร่วมกัน',
                },
            ],
        },
    },
    da: {
        textToVideo: {
            title: 'Gratis AI Tekst til Video: Prompts til Videoer | WeryAI',
            description: 'Omdrej tekstprompter til filmiske AI-videoer gratis. Med Veo 3.1, Sora 2, Kling & Seedance. Flere formater og varigheder. Prøv WeryAI nu!',
            keywords: 'tekst til video AI, gratis tekst til video generator, AI tekst til video, prompt til video, txt2vid, AI video fra tekst, tekst til video online, WeryAI',
            og_title: 'Gratis AI Tekst til Video: Prompts til Videoer | WeryAI',
            og_description: 'Omdrej tekstprompter til filmiske AI-videoer gratis. Med Veo 3.1, Sora 2, Kling & Seedance. Flere formater og varigheder. Prøv WeryAI nu!',
            twitter_title: 'Gratis AI Tekst til Video: Prompts til Videoer | WeryAI',
            twitter_description: 'Omdrej tekstprompter til filmiske AI-videoer gratis. Med Veo 3.1, Sora 2, Kling & Seedance. Flere formater og varigheder. Prøv WeryAI nu!',
            page: {
                title1: 'Gratis AI tekst-til-video generator',
                title2: 'Skriv blot en prompt, og se WeryAI gøre din idé levende. Vores tekst-til-video-generator samler topmodeller som Google Veo 3.1 og Kling AI, så du kan skabe videoer i høj kvalitet og fysisk sammenhæng til sociale medier (9:16) eller filmiske projekter (16:9) på få sekunder.',
                intro_title: 'Gør fantasi til virkelighed med AI tekst-til-video',
                feature_title: 'Funktioner i WeryAI tekst-til-video',
                faq_title: 'Ofte stillede spørgsmål om tekst-til-video',
                feature_title1: 'Kraftfuld multi-model',
                feature_desc1: 'Skift mellem Veo 3.1 for realisme og Kling for konsistent bevægelse. Ingen behov for flere abonnementer.',
                feature_title2: 'Tilpassede billedformater',
                feature_desc2: 'Generer lodrette videoer (9:16) til TikTok/Reels eller bredformat (16:9) til YouTube direkte.',
                feature_title3: 'Forlænget varighed',
                feature_desc3: 'Lav videoer op til 8 sekunder (eller længere med udvidelser) i én generering, perfekt til storytelling.',
                faq: [
                    {
                        question: 'Hvordan skriver jeg en god prompt til AI tekst-til-video?',
                        answer: 'Vær specifik: beskriv motiv, handling, lys og kameravinkel. Fx: "Et filmisk drone-shot af en futuristisk cyberpunk-by om natten, neonlys, 4K". De integrerede modeller i WeryAI forstår komplekse beskrivelser godt.',
                    },
                    {
                        question: 'Hvilken model skal jeg bruge: Google Veo 3.1 eller Kling?',
                        answer: 'Google Veo 3.1 giver høj visuel kvalitet og følger prompten godt, ideel til realistiske scener. Kling AI klarer ofte komplekse karakterbevægelser bedre. Vi anbefaler at prøve begge.',
                    },
                    {
                        question: 'Kan jeg bruge WeryAI tekst-til-video gratis?',
                        answer: 'Ja! Nye brugere får gratis kreditter ved tilmelding — intet kreditkort påkrævet. Du kan også tjene flere gratis kreditter hver dag via dagligt check-in, fuldførelse af opgaver og invitation af venner. Gratis kreditter lader dig lave flere klip for at teste forskellige prompts og modeller.',
                    },
                    {
                        question: 'Kan jeg generere videoer længere end 8 sekunder?',
                        answer: 'Basisgenerering laver klip op til 8 sekunder (afhængigt af modellen). For længere videoer kan du bruge vores AI Video Extender-værktøj til at fortsætte optagelsen sømløst.',
                    },
                    {
                        question: 'Har de genererede videoer lyd?',
                        answer: 'Ja, du kan aktivere "Generate Audio"-knappen (i værktøjet) for automatisk at skabe matchende lydeffekter og baggrundsambience.',
                    },
                    {
                        question: 'Hvilke andre AI-videoskabelsesmetoder tilbyder WeryAI?',
                        answer: 'Udover tekst-til-video tilbyder WeryAI <a href="/image-to-video">Image to Video</a> til at animere dine fotos og <a href="/video-to-video">Video to Video</a> til at omstilelere eksisterende optagelser til anime, 3D-kunst eller cyberpunk. Alle værktøjer deler de samme gratis daglige kreditter.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hvordan skriver jeg en god prompt til AI tekst-til-video?',
                    answer: 'Vær specifik: beskriv motiv, handling, lys og kameravinkel. Fx: "Et filmisk drone-shot af en futuristisk cyberpunk-by om natten, neonlys, 4K". De integrerede modeller i WeryAI forstår komplekse beskrivelser godt.',
                },
                {
                    question: 'Hvilken model skal jeg bruge: Google Veo 3.1 eller Kling?',
                    answer: 'Google Veo 3.1 giver høj visuel kvalitet og følger prompten godt, ideel til realistiske scener. Kling AI klarer ofte komplekse karakterbevægelser bedre. Vi anbefaler at prøve begge.',
                },
                {
                    question: 'Kan jeg bruge WeryAI tekst-til-video gratis?',
                    answer: 'Ja! Nye brugere får gratis kreditter ved tilmelding — intet kreditkort påkrævet. Du kan også tjene flere gratis kreditter hver dag via dagligt check-in, fuldførelse af opgaver og invitation af venner. Gratis kreditter lader dig lave flere klip for at teste forskellige prompts og modeller.',
                },
                {
                    question: 'Kan jeg generere videoer længere end 8 sekunder?',
                    answer: 'Basisgenerering laver klip op til 8 sekunder (afhængigt af modellen). For længere videoer kan du bruge vores AI Video Extender-værktøj til at fortsætte optagelsen sømløst.',
                },
                {
                    question: 'Har de genererede videoer lyd?',
                    answer: 'Ja, du kan aktivere "Generate Audio"-knappen (i værktøjet) for automatisk at skabe matchende lydeffekter og baggrundsambience.',
                },
                {
                    question: 'Hvilke andre AI-videoskabelsesmetoder tilbyder WeryAI?',
                    answer: 'Udover tekst-til-video tilbyder WeryAI Image to Video til at animere dine fotos og Video to Video til at omstilere eksisterende optagelser til anime, 3D-kunst eller cyberpunk. Alle værktøjer deler de samme gratis daglige kreditter.',
                },
            ],
        },
    },
    no: {
        textToVideo: {
            title: 'Gratis AI Tekst til Video: Prompts til Videoer | WeryAI',
            description: 'Gjør tekstprompter om til filmatiske AI-videoer gratis. Med Veo 3.1, Sora 2, Kling & Seedance. Flere formater og varigheter. Prøv WeryAI nå!',
            keywords: 'tekst til video AI, gratis tekst til video generator, AI tekst til video, prompt til video, txt2vid, AI video fra tekst, tekst til video online, WeryAI',
            og_title: 'Gratis AI Tekst til Video: Prompts til Videoer | WeryAI',
            og_description: 'Gjør tekstprompter om til filmatiske AI-videoer gratis. Med Veo 3.1, Sora 2, Kling & Seedance. Flere formater og varigheter. Prøv WeryAI nå!',
            twitter_title: 'Gratis AI Tekst til Video: Prompts til Videoer | WeryAI',
            twitter_description: 'Gjør tekstprompter om til filmatiske AI-videoer gratis. Med Veo 3.1, Sora 2, Kling & Seedance. Flere formater og varigheter. Prøv WeryAI nå!',
            page: {
                title1: 'Gratis AI tekst-til-video-generator',
                title2: 'Bare skriv inn en prompt, og se WeryAI gi liv til ideen din. Vår tekst-til-video-generator samler toppmodeller som Google Veo 3.1 og Kling AI, slik at du kan lage videoer i høy kvalitet og fysisk konsistens for sosiale medier (9:16) eller filmatiske prosjekter (16:9) på sekunder.',
                intro_title: 'Gjør fantasi til virkelighet med AI tekst-til-video',
                feature_title: 'Funksjoner i WeryAI tekst-til-video',
                faq_title: 'Ofte stilte spørsmål om tekst-til-video',
                feature_title1: 'Kraftig fler-modell',
                feature_desc1: 'Bytt mellom Veo 3.1 for realisme og Kling for bevegelseskonsistens. Ingen behov for flere abonnementer.',
                feature_title2: 'Tilpassede sideforhold',
                feature_desc2: 'Lag vertikale videoer (9:16) for TikTok/Reels eller bredformat (16:9) for YouTube direkte.',
                feature_title3: 'Lengre varighet',
                feature_desc3: 'Lag videoer opptil 8 sekunder (eller lenger med utvidelser) i én generering, perfekt for historiefortelling.',
                faq: [
                    {
                        question: 'Hvordan skriver jeg en god prompt for AI tekst-til-video?',
                        answer: 'Vær spesifikk: beskriv motiv, handling, lys og kameravinkel. For eksempel: "Et filmatisk droneopptak av en futuristisk cyberpunk-by om natten, neonlys, 4K". De integrerte modellene i WeryAI forstår komplekse beskrivelser godt.',
                    },
                    {
                        question: 'Hvilken modell bør jeg bruke: Google Veo 3.1 eller Kling?',
                        answer: 'Google Veo 3.1 gir eksepsjonell visuell kvalitet og følger prompten godt, ideelt for realistiske scener. Kling AI fungerer ofte bedre for komplekse karakterbevegelser. Vi anbefaler å prøve begge.',
                    },
                    {
                        question: 'Kan jeg bruke WeryAI tekst-til-video gratis?',
                        answer: 'Ja! Nye brukere får gratis kreditter ved registrering — ingen kredittkort nødvendig. Du kan også tjene flere gratis kreditter hver dag gjennom daglig innsjekk, fullføring av oppgaver og invitasjon av venner. Gratis kreditter lar deg lage flere klipp for å teste ulike prompt og modeller.',
                    },
                    {
                        question: 'Kan jeg generere videoer lengre enn 8 sekunder?',
                        answer: 'Grunngenereringen lager klipp opptil 8 sekunder (avhengig av modellen). For lengre videoer kan du bruke vårt AI Video Extender-verktøy for å fortsette opptaket sømløst.',
                    },
                    {
                        question: 'Har de genererte videoene lyd?',
                        answer: 'Ja, du kan aktivere "Generate Audio"-bryteren (i verktøyet) for automatisk å lage matchende lydeffekter og bakgrunnsambience.',
                    },
                    {
                        question: 'Hvilke andre AI-videoskapingsmetoder tilbyr WeryAI?',
                        answer: 'I tillegg til tekst-til-video tilbyr WeryAI <a href="/image-to-video">Image to Video</a> for å animere bildene dine og <a href="/video-to-video">Video to Video</a> for å omstile eksisterende opptak til anime, 3D-kunst eller cyberpunk. Alle verktøy deler de samme gratis daglige kredittene.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Hvordan skriver jeg en god prompt for AI tekst-til-video?',
                    answer: 'Vær spesifikk: beskriv motiv, handling, lys og kameravinkel. For eksempel: "Et filmatisk droneopptak av en futuristisk cyberpunk-by om natten, neonlys, 4K". De integrerte modellene i WeryAI forstår komplekse beskrivelser godt.',
                },
                {
                    question: 'Hvilken modell bør jeg bruke: Google Veo 3.1 eller Kling?',
                    answer: 'Google Veo 3.1 gir eksepsjonell visuell kvalitet og følger prompten godt, ideelt for realistiske scener. Kling AI fungerer ofte bedre for komplekse karakterbevegelser. Vi anbefaler å prøve begge.',
                },
                {
                    question: 'Kan jeg bruke WeryAI tekst-til-video gratis?',
                    answer: 'Ja! Nye brukere får gratis kreditter ved registrering — ingen kredittkort nødvendig. Du kan også tjene flere gratis kreditter hver dag gjennom daglig innsjekk, fullføring av oppgaver og invitasjon av venner. Gratis kreditter lar deg lage flere klipp for å teste ulike prompt og modeller.',
                },
                {
                    question: 'Kan jeg generere videoer lengre enn 8 sekunder?',
                    answer: 'Grunngenereringen lager klipp opptil 8 sekunder (avhengig av modellen). For lengre videoer kan du bruke vårt AI Video Extender-verktøy for å fortsette opptaket sømløst.',
                },
                {
                    question: 'Har de genererte videoene lyd?',
                    answer: 'Ja, du kan aktivere "Generate Audio"-bryteren (i verktøyet) for automatisk å lage matchende lydeffekter og bakgrunnsambience.',
                },
                {
                    question: 'Hvilke andre AI-videoskapingsmetoder tilbyr WeryAI?',
                    answer: 'I tillegg til tekst-til-video tilbyr WeryAI Image to Video for å animere bildene dine og Video to Video for å omstile eksisterende opptak til anime, 3D-kunst eller cyberpunk. Alle verktøy deler de samme gratis daglige kredittene.',
                },
            ],
        },
    },
    nl: {
        textToVideo: {
            title: 'Gratis AI Tekst naar Video: Prompts naar Video\'s | WeryAI',
            description: 'Zet tekstprompts gratis om in filmische AI-video\'s. Met Veo 3.1, Sora 2, Kling & Seedance. Meerdere verhoudingen & duur. Probeer WeryAI nu!',
            keywords: 'tekst naar video AI, gratis tekst naar video generator, AI tekst naar video, prompt naar video, txt2vid, AI video van tekst, tekst naar video online, WeryAI',
            og_title: 'Gratis AI Tekst naar Video: Prompts naar Video\'s | WeryAI',
            og_description: 'Zet tekstprompts gratis om in filmische AI-video\'s. Met Veo 3.1, Sora 2, Kling & Seedance. Meerdere verhoudingen & duur. Probeer WeryAI nu!',
            twitter_title: 'Gratis AI Tekst naar Video: Prompts naar Video\'s | WeryAI',
            twitter_description: 'Zet tekstprompts gratis om in filmische AI-video\'s. Met Veo 3.1, Sora 2, Kling & Seedance. Meerdere verhoudingen & duur. Probeer WeryAI nu!',
            page: {
                title1: 'Gratis AI tekst-naar-video generator',
                title2: `Typ gewoon een prompt en zie hoe WeryAI je idee tot leven brengt. Onze tekst-naar-video generator bundelt topmodellen zoals Google Veo 3.1 en Kling AI, zodat je in enkele seconden hoogwaardige, fysiek consistente video's kunt maken voor social media (9:16) of filmische projecten (16:9).`,
                intro_title: 'Maak van verbeelding werkelijkheid met AI tekst-naar-video',
                feature_title: 'Functies van WeryAI tekst-naar-video',
                faq_title: 'Veelgestelde vragen over tekst-naar-video',
                feature_title1: 'Krachtige multi-model',
                feature_desc1: 'Schakel tussen Veo 3.1 voor realisme en Kling voor consistente beweging. Geen meerdere abonnementen nodig.',
                feature_title2: 'Aangepaste beeldverhoudingen',
                feature_desc2: `Genereer verticale video's (9:16) voor TikTok/Reels of breedbeeld (16:9) voor YouTube direct.`,
                feature_title3: 'Langere duur',
                feature_desc3: `Maak video's tot 8 seconden (of langer met extensies) in één generatie, perfect voor storytelling.`,
                faq: [
                    {
                        question: 'Hoe schrijf ik een goede prompt voor AI tekst-naar-video?',
                        answer: 'Wees specifiek: beschrijf onderwerp, actie, belichting en camerahoek. Bijvoorbeeld: "Een filmische drone-opname van een futuristische cyberpunkstad in de nacht, neonlichten, 4K". De geïntegreerde modellen van WeryAI begrijpen complexe beschrijvingen goed.',
                    },
                    {
                        question: 'Welk model moet ik gebruiken: Google Veo 3.1 of Kling?',
                        answer: 'Google Veo 3.1 biedt uitzonderlijke visuele kwaliteit en houdt zich goed aan de prompt, ideaal voor realistische scènes. Kling AI presteert vaak beter bij complexe karakterbewegingen. We raden aan beide te proberen.',
                    },
                    {
                        question: 'Kan ik WeryAI tekst-naar-video gratis gebruiken?',
                        answer: `Ja! Nieuwe gebruikers krijgen gratis credits bij registratie — geen creditcard nodig. Je kunt ook elke dag meer gratis credits verdienen via dagelijkse check-in, het voltooien van taken en het uitnodigen van vrienden. Gratis credits stellen je in staat meerdere clips te maken om verschillende prompts en modellen te testen.`,
                    },
                    {
                        question: `Kan ik video's genereren langer dan 8 seconden?`,
                        answer: `De basisgeneratie maakt clips tot 8 seconden (afhankelijk van het model). Voor langere video's kun je onze AI Video Extender-tool gebruiken om het beeld naadloos te verlengen.`,
                    },
                    {
                        question: `Hebben de gegenereerde video's geluid?`,
                        answer: 'Ja, je kunt de schakelaar "Generate Audio" (in de tool) inschakelen om automatisch bijpassende geluidseffecten en achtergrondambience te maken.',
                    },
                    {
                        question: 'Welke andere AI-videocreatiemethoden biedt WeryAI?',
                        answer: `Naast tekst-naar-video biedt WeryAI <a href="/image-to-video">Image to Video</a> om je foto's te animeren en <a href="/video-to-video">Video to Video</a> om bestaande beelden om te zetten naar anime, 3D-kunst of cyberpunk. Alle tools delen dezelfde gratis dagelijkse credits.`,
                    },
                ],
            },
            faq: [
                {
                    question: 'Hoe schrijf ik een goede prompt voor AI tekst-naar-video?',
                    answer: 'Wees specifiek: beschrijf onderwerp, actie, belichting en camerahoek. Bijvoorbeeld: "Een filmische drone-opname van een futuristische cyberpunkstad in de nacht, neonlichten, 4K". De geïntegreerde modellen van WeryAI begrijpen complexe beschrijvingen goed.',
                },
                {
                    question: 'Welk model moet ik gebruiken: Google Veo 3.1 of Kling?',
                    answer: 'Google Veo 3.1 biedt uitzonderlijke visuele kwaliteit en houdt zich goed aan de prompt, ideaal voor realistische scènes. Kling AI presteert vaak beter bij complexe karakterbewegingen. We raden aan beide te proberen.',
                },
                {
                    question: 'Kan ik WeryAI tekst-naar-video gratis gebruiken?',
                    answer: `Ja! Nieuwe gebruikers krijgen gratis credits bij registratie — geen creditcard nodig. Je kunt ook elke dag meer gratis credits verdienen via dagelijkse check-in, het voltooien van taken en het uitnodigen van vrienden. Gratis credits stellen je in staat meerdere clips te maken om verschillende prompts en modellen te testen.`,
                },
                {
                    question: `Kan ik video's genereren langer dan 8 seconden?`,
                    answer: `De basisgeneratie maakt clips tot 8 seconden (afhankelijk van het model). Voor langere video's kun je onze AI Video Extender-tool gebruiken om het beeld naadloos te verlengen.`,
                },
                {
                    question: `Hebben de gegenereerde video's geluid?`,
                    answer: 'Ja, je kunt de schakelaar "Generate Audio" (in de tool) inschakelen om automatisch bijpassende geluidseffecten en achtergrondambience te maken.',
                },
                {
                    question: 'Welke andere AI-videocreatiemethoden biedt WeryAI?',
                    answer: `Naast tekst-naar-video biedt WeryAI Image to Video om je foto's te animeren en Video to Video om bestaande beelden om te zetten naar anime, 3D-kunst of cyberpunk. Alle tools delen dezelfde gratis dagelijkse credits.`,
                },
            ],
        },
    },
    id: {
        textToVideo: {
            title: 'AI Teks ke Video Gratis: Prompt Jadi Video | WeryAI',
            description: 'Ubah prompt teks menjadi video AI sinematik secara gratis. Didukung Veo 3.1, Sora 2, Kling & Seedance. Berbagai rasio & durasi. Coba WeryAI sekarang!',
            keywords: 'teks ke video AI, generator teks ke video gratis, AI teks ke video, prompt ke video, txt2vid, video AI dari teks, teks ke video online, WeryAI',
            og_title: 'AI Teks ke Video Gratis: Prompt Jadi Video | WeryAI',
            og_description: 'Ubah prompt teks menjadi video AI sinematik secara gratis. Didukung Veo 3.1, Sora 2, Kling & Seedance. Berbagai rasio & durasi. Coba WeryAI sekarang!',
            twitter_title: 'AI Teks ke Video Gratis: Prompt Jadi Video | WeryAI',
            twitter_description: 'Ubah prompt teks menjadi video AI sinematik secara gratis. Didukung Veo 3.1, Sora 2, Kling & Seedance. Berbagai rasio & durasi. Coba WeryAI sekarang!',
            page: {
                title1: 'Generator AI Teks ke Video Gratis',
                title2: 'Cukup ketik prompt dan lihat WeryAI mewujudkan ide Anda. Generator teks ke video kami menggabungkan model mutakhir seperti Google Veo 3.1 dan Kling AI, sehingga Anda dapat membuat video berkualitas tinggi dan konsisten secara fisik untuk media sosial (9:16) atau proyek sinematik (16:9) hanya dalam hitungan detik.',
                intro_title: 'Ubah imajinasi menjadi kenyataan dengan AI teks ke video',
                feature_title: 'Fitur WeryAI teks ke video',
                faq_title: 'Pertanyaan umum tentang teks ke video',
                feature_title1: 'Kekuatan multi-model',
                feature_desc1: 'Beralih antara Veo 3.1 untuk realisme dan Kling untuk konsistensi gerak. Tidak perlu banyak langganan.',
                feature_title2: 'Rasio aspek kustom',
                feature_desc2: 'Buat video vertikal (9:16) untuk TikTok/Reels atau layar lebar (16:9) untuk YouTube secara langsung.',
                feature_title3: 'Durasi lebih panjang',
                feature_desc3: 'Buat video hingga 8 detik (atau lebih lama dengan ekstensi) dalam sekali generasi, ideal untuk bercerita.',
                faq: [
                    {
                        question: 'Bagaimana menulis prompt yang baik untuk AI teks ke video?',
                        answer: 'Jelaskan secara spesifik: subjek, aksi, pencahayaan, dan sudut kamera. Contoh: "Bidikan drone sinematik kota cyberpunk futuristik pada malam hari, lampu neon, 4K". Model terintegrasi WeryAI memahami deskripsi kompleks dengan baik.',
                    },
                    {
                        question: 'Model mana yang sebaiknya saya gunakan: Google Veo 3.1 atau Kling?',
                        answer: 'Google Veo 3.1 menawarkan kualitas visual tinggi dan kepatuhan prompt yang kuat, ideal untuk adegan realistis. Kling AI sering lebih baik untuk gerakan karakter kompleks. Kami sarankan mencoba keduanya.',
                    },
                    {
                        question: 'Bisakah saya menggunakan WeryAI teks ke video secara gratis?',
                        answer: 'Ya! Pengguna baru mendapatkan kredit gratis saat mendaftar — tanpa perlu kartu kredit. Anda juga bisa mendapatkan lebih banyak kredit gratis setiap hari melalui check-in harian, menyelesaikan tugas, dan mengundang teman. Kredit gratis memungkinkan Anda membuat beberapa klip untuk menguji prompt dan model yang berbeda.',
                    },
                    {
                        question: 'Bisakah saya membuat video lebih dari 8 detik?',
                        answer: 'Generasi dasar membuat klip hingga 8 detik (tergantung model). Untuk video lebih panjang, gunakan alat AI Video Extender agar footage berlanjut secara mulus.',
                    },
                    {
                        question: 'Apakah video yang dihasilkan memiliki suara?',
                        answer: 'Ya, Anda dapat mengaktifkan toggle "Generate Audio" (di alat) untuk membuat efek suara dan ambience latar secara otomatis.',
                    },
                    {
                        question: 'Metode pembuatan video AI apa lagi yang ditawarkan WeryAI?',
                        answer: 'Selain teks ke video, WeryAI menawarkan <a href="/image-to-video">Image to Video</a> untuk menganimasikan foto Anda dan <a href="/video-to-video">Video to Video</a> untuk mengubah rekaman yang ada menjadi anime, seni 3D, atau cyberpunk. Semua alat berbagi kredit gratis harian yang sama.',
                    },
                ],
            },
            faq: [
                {
                    question: 'Bagaimana menulis prompt yang baik untuk AI teks ke video?',
                    answer: 'Jelaskan secara spesifik: subjek, aksi, pencahayaan, dan sudut kamera. Contoh: "Bidikan drone sinematik kota cyberpunk futuristik pada malam hari, lampu neon, 4K". Model terintegrasi WeryAI memahami deskripsi kompleks dengan baik.',
                },
                {
                    question: 'Model mana yang sebaiknya saya gunakan: Google Veo 3.1 atau Kling?',
                    answer: 'Google Veo 3.1 menawarkan kualitas visual tinggi dan kepatuhan prompt yang kuat, ideal untuk adegan realistis. Kling AI sering lebih baik untuk gerakan karakter kompleks. Kami sarankan mencoba keduanya.',
                },
                {
                    question: 'Bisakah saya menggunakan WeryAI teks ke video secara gratis?',
                    answer: 'Ya! Pengguna baru mendapatkan kredit gratis saat mendaftar — tanpa perlu kartu kredit. Anda juga bisa mendapatkan lebih banyak kredit gratis setiap hari melalui check-in harian, menyelesaikan tugas, dan mengundang teman. Kredit gratis memungkinkan Anda membuat beberapa klip untuk menguji prompt dan model yang berbeda.',
                },
                {
                    question: 'Bisakah saya membuat video lebih dari 8 detik?',
                    answer: 'Generasi dasar membuat klip hingga 8 detik (tergantung model). Untuk video lebih panjang, gunakan alat AI Video Extender agar footage berlanjut secara mulus.',
                },
                {
                    question: 'Apakah video yang dihasilkan memiliki suara?',
                    answer: 'Ya, Anda dapat mengaktifkan toggle "Generate Audio" (di alat) untuk membuat efek suara dan ambience latar secara otomatis.',
                },
                {
                    question: 'Metode pembuatan video AI apa lagi yang ditawarkan WeryAI?',
                    answer: 'Selain teks ke video, WeryAI menawarkan Image to Video untuk menganimasikan foto Anda dan Video to Video untuk mengubah rekaman yang ada menjadi anime, seni 3D, atau cyberpunk. Semua alat berbagi kredit gratis harian yang sama.',
                },
            ],
        },
    },
    tr: {
        textToVideo: {
            title: 'Ücretsiz AI Metinden Videoya: Promptlar Videolara | WeryAI',
            description: 'Metin promptlarını sinematik AI videolara ücretsiz dönüştürün. Veo 3.1, Sora 2, Kling & Seedance ile. Çoklu oran ve süre desteği. WeryAI\'yi şimdi deneyin!',
            keywords: 'metinden videoya AI, ücretsiz metinden video üretici, AI metin video, prompttan video, txt2vid, metinden AI video, metinden videoya online, WeryAI',
            og_title: 'Ücretsiz AI Metinden Videoya: Promptlar Videolara | WeryAI',
            og_description: 'Metin promptlarını sinematik AI videolara ücretsiz dönüştürün. Veo 3.1, Sora 2, Kling & Seedance ile. Çoklu oran ve süre desteği. WeryAI\'yi şimdi deneyin!',
            twitter_title: 'Ücretsiz AI Metinden Videoya: Promptlar Videolara | WeryAI',
            twitter_description: 'Metin promptlarını sinematik AI videolara ücretsiz dönüştürün. Veo 3.1, Sora 2, Kling & Seedance ile. Çoklu oran ve süre desteği. WeryAI\'yi şimdi deneyin!',
            page: {
                title1: 'Ücretsiz AI Metinden Videoya Üretici',
                title2: `Sadece bir istem yazın ve WeryAI'nin fikrinizi hayata geçirdiğini görün. Metinden Videoya üreticimiz Google Veo 3.1 ve Kling AI gibi en iyi modelleri bir araya getirir; sosyal medya (9:16) ya da sinematik projeler (16:9) için fiziksel olarak tutarlı, yüksek kaliteli videoları saniyeler içinde oluşturabilirsiniz.`,
                intro_title: 'AI metinden videoya ile hayali gerçeğe dönüştürün',
                feature_title: 'WeryAI Metinden Videoya özellikleri',
                faq_title: 'Metinden videoya hakkında sık sorulan sorular',
                feature_title1: 'Çoklu model gücü',
                feature_desc1: 'Gerçekçilik için Veo 3.1 ile hareket tutarlılığı için Kling arasında geçiş yapın. Birden fazla aboneliğe gerek yok.',
                feature_title2: 'Özel en-boy oranları',
                feature_desc2: 'TikTok/Reels için dikey (9:16) veya YouTube için geniş (16:9) videoları doğrudan üretin.',
                feature_title3: 'Uzatılmış süre',
                feature_desc3: 'Tek bir üretimde 8 saniyeye kadar (veya uzatmalarla daha uzun) video oluşturun; hikaye anlatımı için idealdir.',
                faq: [
                    {
                        question: 'AI metinden videoya için iyi bir istem nasıl yazılır?',
                        answer: 'Özgül olun: konu, hareket, ışık ve kamera açısını tarif edin. Örneğin: "Gecede futuristik siberpunk şehirde sinematik drone çekimi, neon ışıklar, 4K". WeryAI entegre modelleri karmaşık betimlemeleri iyi anlar.',
                    },
                    {
                        question: 'Hangi modeli kullanmalıyım: Google Veo 3.1 mi Kling mi?',
                        answer: 'Google Veo 3.1 üstün görsel kalite ve isteme uyum sağlar, gerçekçi sahneler için idealdir. Kling AI karmaşık karakter hareketlerinde genellikle daha iyidir. İkisini de denemenizi öneririz.',
                    },
                    {
                        question: 'WeryAI Metinden Videoya ücretsiz olarak kullanılabilir mi?',
                        answer: 'Evet! Yeni kullanıcılar kayıt olurken ücretsiz krediler alır — kredi kartı gerekmez. Ayrıca günlük giriş, görevleri tamamlama ve arkadaş davet etme yoluyla her gün daha fazla ücretsiz kredi kazanabilirsiniz. Ücretsiz krediler, farklı istemleri ve modelleri denemek için birden fazla klip oluşturmanızı sağlar.',
                    },
                    {
                        question: '8 saniyeden uzun videolar oluşturabilir miyim?',
                        answer: 'Temel üretim 8 saniyeye kadar klip oluşturur (modele bağlı). Daha uzun videolar için AI Video Extender aracımızı kullanarak görüntüyü sorunsuz şekilde uzatabilirsiniz.',
                    },
                    {
                        question: 'Oluşturulan videolarda ses var mı?',
                        answer: 'Evet, araçtaki "Generate Audio" anahtarını etkinleştirerek uygun ses efektleri ve arka plan ambiyansı otomatik oluşturabilirsiniz.',
                    },
                    {
                        question: 'WeryAI başka hangi AI video oluşturma yöntemlerini sunuyor?',
                        answer: 'Metinden videoya yanı sıra WeryAI, fotoğraflarınızı canlandırmak için <a href="/image-to-video">Image to Video</a> ve mevcut çekimleri anime, 3D sanat veya siberpunk\'a dönüştürmek için <a href="/video-to-video">Video to Video</a> sunmaktadır. Tüm araçlar aynı günlük ücretsiz kreditleri paylaşır.',
                    },
                ],
            },
            faq: [
                {
                    question: 'AI metinden videoya için iyi bir istem nasıl yazılır?',
                    answer: 'Özgül olun: konu, hareket, ışık ve kamera açısını tarif edin. Örneğin: "Gecede futuristik siberpunk şehirde sinematik drone çekimi, neon ışıklar, 4K". WeryAI entegre modelleri karmaşık betimlemeleri iyi anlar.',
                },
                {
                    question: 'Hangi modeli kullanmalıyım: Google Veo 3.1 mi Kling mi?',
                    answer: 'Google Veo 3.1 üstün görsel kalite ve isteme uyum sağlar, gerçekçi sahneler için idealdir. Kling AI karmaşık karakter hareketlerinde genellikle daha iyidir. İkisini de denemenizi öneririz.',
                },
                {
                    question: 'WeryAI Metinden Videoya ücretsiz olarak kullanılabilir mi?',
                    answer: 'Evet! Yeni kullanıcılar kayıt olurken ücretsiz krediler alır — kredi kartı gerekmez. Ayrıca günlük giriş, görevleri tamamlama ve arkadaş davet etme yoluyla her gün daha fazla ücretsiz kredi kazanabilirsiniz. Ücretsiz krediler, farklı istemleri ve modelleri denemek için birden fazla klip oluşturmanızı sağlar.',
                },
                {
                    question: '8 saniyeden uzun videolar oluşturabilir miyim?',
                    answer: 'Temel üretim 8 saniyeye kadar klip oluşturur (modele bağlı). Daha uzun videolar için AI Video Extender aracımızı kullanarak görüntüyü sorunsuz şekilde uzatabilirsiniz.',
                },
                {
                    question: 'Oluşturulan videolarda ses var mı?',
                    answer: 'Evet, araçtaki "Generate Audio" anahtarını etkinleştirerek uygun ses efektleri ve arka plan ambiyansı otomatik oluşturabilirsiniz.',
                },
                {
                    question: 'WeryAI başka hangi AI video oluşturma yöntemlerini sunuyor?',
                    answer: 'Metinden videoya yanı sıra WeryAI, fotoğraflarınızı canlandırmak için Image to Video ve mevcut çekimleri anime, 3D sanat veya siberpunk\'a dönüştürmek için Video to Video sunmaktadır. Tüm araçlar aynı günlük ücretsiz kreditleri paylaşır.',
                },
            ],
        },
    },
}
